/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
/* eslint-disable indent */
import React from "react";
import { useMemo } from "react";
import { useState, useEffect, useCallback } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import adigitalLogo from "../../img/adigital-logo.png";
import regionLogo from "../../img/region-logo.png";
import visionaLogo from "../../img/visiona-logo.png";
import wecastLogo from "../../img/wecast-logo.png";
import {
  client,
  deleteCostoHardwareFlex,
  getClientes,
  getContratos,
  getCostosFijos,
  getCostosGestion,
  getDepreciacionYAmortizacion,
  getInversionMensual,
  getValorActivosMensual,
  getCostosHardwareFlex,
  getCostosPublicidad,
  getConvertedImporte,
  getEdificios,
  getEmpleados,
  getIntermediarios,
  getOportunidades,
  getRateForOpp,
  getRemuneracionesEmpleado,
  getUsers,
  upsertCostoGestion,
  upsertCostosPublicidad,
} from "../../utils";
import { calcularComisionesFijasMensuales, esEdificioComisionFija } from "../../utils/comisionEdificiosUtil";
import { cargarSnapshotDenominadores } from "../../utils/comisionSnapshot";
import { cargarCostosIntermediacion } from "../../utils/costosIntermediacion";
import { calcularDolarPromedioAno, loadExchangeRates } from "../../utils/exchangeRateService";
import { useExchangeRates } from "../../utils/useExchangeRates";

import { AgencyCommissionModal } from "./components/AgencyCommissionModal";
import { AsesoriaExternaModal } from "./components/AsesoriaExternaModal";
import { BloqueBTable } from "./components/BloqueBTable";
import { BloqueCTable } from "./components/BloqueCTable";
import { BloqueDTable } from "./components/BloqueDTable";
import { BTLModal } from "./components/BTLModal";
import { BuildingCommissionModal } from "./components/BuildingCommissionModal";
import { CommercialCommissionModal } from "./components/CommercialCommissionModal";
import { CostosFijosTable } from "./components/CostosFijosTable";
import { EBITDAResultadoTable } from "./components/EBITDAResultadoTable";
import { EditCostModal } from "./components/EditCostModal";
import { ERChartModal } from "./components/ERChartModal";
import { ERHeader } from "./components/ERHeader";
import { GestionContenidosModal } from "./components/GestionContenidosModal";
import { HardwareFlexModal } from "./components/HardwareFlexModal";
import { HardwareIngresosModal } from "./components/HardwareIngresosModal";
import { InteresesModal } from "./components/InteresesModal";
import { InvoiceModal } from "./components/InvoiceModal";
import { SoftwareDSModal } from "./components/SoftwareDSModal";
import { VariosModal } from "./components/VariosModal";
import {
  meses,
  mesesCompletos,
  camposCostosFijos,
  nombresCostosFijos,
  conceptosManuales,
  interesesMensualesUSD,
  impuestosMensualesUSD,
  windowArray,
} from "./constants";
import { useBTLCalcs } from "./hooks/useBTLCalcs";
import { useContratosCalcs } from "./hooks/useContratosCalcs";
import { useCostosFijosCalcs } from "./hooks/useCostosFijosCalcs";
import { useEBITDACalcs } from "./hooks/useEBITDACalcs";
import { useERFormatting } from "./hooks/useERFormatting";
import { useGestionCalcs } from "./hooks/useGestionCalcs";
import { useHardwareCalcs } from "./hooks/useHardwareCalcs";
import { usePublicidadCalcs } from "./hooks/usePublicidadCalcs";
import { useRRHHCalculations } from "./hooks/useRRHHCalculations";
import { useUnitEconomics } from "./hooks/useUnitEconomics";
import "../../assets/stylesChart.scss";
import styles from "./stylesER.module.scss";

export const ER = ({ showInDollars = false, setShowInDollars }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const initialYear = currentMonth === 0 ? currentYear - 1 : currentYear;
  const [selectedYear, setSelectedYear] = useState(initialYear);
  const monthsToShow = selectedYear < currentYear ? 12 : currentMonth;
  const [clientes, setClientes] = useState({});
  const [edificios, setEdificios] = useState({});
  const [intermediarios, setIntermediarios] = useState({});
  const [isBuildingCommissionModalOpen, setIsBuildingCommissionModalOpen] = useState(false);
  const [isAgencyModalOpen, setIsAgencyModalOpen] = useState(false);
  const [isCommercialModalOpen, setIsCommercialModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // === DATOS POR PAÍS (cargan ambos siempre) ===
  const [oportunidadesChile, setOportunidadesChile] = useState([]);
  const [oportunidadesPeru, setOportunidadesPeru] = useState([]);
  const [clientesChile, setClientesChile] = useState({});
  const [clientesPeru, setClientesPeru] = useState({});
  const [intermediariosChile, setIntermediariosChile] = useState({});
  const [intermediariosPeru, setIntermediariosPeru] = useState({});
  const [edificiosChile, setEdificiosChile] = useState({});
  const [edificiosPeru, setEdificiosPeru] = useState({});
  // Snapshot de comisión (Paso 5): denominador congelado por país. Fallback a pantallastotales si null.
  const [snapMap, setSnapMap] = useState(null);
  const [snapMapChile, setSnapMapChile] = useState(null);
  const [snapMapPeru, setSnapMapPeru] = useState(null);
  // FASE 6: costos de intermediación que reducen la base de comisión (take programático), por país.
  const [costosMap, setCostosMap] = useState(null);
  const [costosMapChile, setCostosMapChile] = useState(null);
  const [costosMapPeru, setCostosMapPeru] = useState(null);
  const [negociosCarteleriaChile, setNegociosCarteleriaChile] = useState([]);
  const [negociosCarteleriaPeru, setNegociosCarteleriaPeru] = useState([]);
  const [salesBTLChile, setSalesBTLChile] = useState([]);
  const [salesBTLPeru, setSalesBTLPeru] = useState([]);
  // BTL año anterior para Run Rate
  const [salesBTLChileAnoAnterior, setSalesBTLChileAnoAnterior] = useState([]);
  const [salesBTLPeruAnoAnterior, setSalesBTLPeruAnoAnterior] = useState([]);
  // Contratos multi-mes
  const [contratosChile, setContratosChile] = useState([]);
  const [contratosPeru, setContratosPeru] = useState([]);
  // Estados para modo combinado (datos del otro país)
  // eslint-disable-next-line no-unused-vars
  const [costosFijosOtroPais, setCostosFijosOtroPais] = useState([]);
  const [datosCombinadosCargados, setDatosCombinadosCargados] = useState(false);
  // Estados FIJOS para costos (ambos países)
  const [costosFijosChile, setCostosFijosChile] = useState([]);
  const [costosFijosPeru, setCostosFijosPeru] = useState([]);
  const [rawCostosFijosChile, setRawCostosFijosChile] = useState([]);
  const [rawCostosFijosPeru, setRawCostosFijosPeru] = useState([]);
  const [costosFijosChileAnoAnterior, setCostosFijosChileAnoAnterior] = useState([]);
  const [costosFijosPeruAnoAnterior, setCostosFijosPeruAnoAnterior] = useState([]);
  const [empleadosRRHHChile, setEmpleadosRRHHChile] = useState([]);
  const [empleadosRRHHPeru, setEmpleadosRRHHPeru] = useState([]);
  // Estados FIJOS para costos hardware (ambos países)
  const [costosHardwareFlexChile, setCostosHardwareFlexChile] = useState([]);
  const [costosHardwareFlexPeru, setCostosHardwareFlexPeru] = useState([]);
  // Estados FIJOS para costos publicidad y gestión (ambos países)
  const [costosPublicidadChile, setCostosPublicidadChile] = useState(Array(12).fill(null));
  const [costosPublicidadPeru, setCostosPublicidadPeru] = useState(Array(12).fill(null));
  const [costosGestionChile, setCostosGestionChile] = useState([]);
  const [costosGestionPeru, setCostosGestionPeru] = useState([]);
  // Año anterior per-country (para proyecciones ventana 12 meses en modo combinado)
  const [costosPublicidadChileAA, setCostosPublicidadChileAA] = useState(Array(12).fill(null));
  const [costosPublicidadPeruAA, setCostosPublicidadPeruAA] = useState(Array(12).fill(null));
  const [costosGestionChileAA, setCostosGestionChileAA] = useState([]);
  const [costosGestionPeruAA, setCostosGestionPeruAA] = useState([]);
  const [isOportunidadesLoading, setIsOportunidadesLoading] = useState(true);
  const [selectedAgencyMonth, setSelectedAgencyMonth] = useState(null);
  const [selectedBuildingCommissionMonth, setSelectedBuildingCommissionMonth] = useState(null);
  const [selectedCommercialMonth, setSelectedCommercialMonth] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [users, setUsers] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingConcept, setEditingConcept] = useState(null);
  const [costosGestionData, setCostosGestionData] = useState([]);
  const [isClientesLoading, setIsClientesLoading] = useState(true);
  const [editValue, setEditValue] = useState(0);
  const [isGestionContenidosModalOpen, setIsGestionContenidosModalOpen] = useState(false);
  const [selectedGestionContenidosMonth, setSelectedGestionContenidosMonth] = useState(null);
  const [costosPublicidadData, setCostosPublicidadData] = useState([]);
  // Estado para datos publicidad año anterior (ventana 12 meses continuos)
  const [costosPublicidadDataAnoAnterior, setCostosPublicidadDataAnoAnterior] = useState([]);
  const [costosFijosData, setCostosFijosData] = useState([]);
  const [isBTLModalOpen, setIsBTLModalOpen] = useState(false);
  const [selectedBTLMonth, setSelectedBTLMonth] = useState(null);
  const [editingBTLId, setEditingBTLId] = useState(null);
  const [tempOtrosCostos, setTempOtrosCostos] = useState("");
  const [costosFijosCollapsed, setCostosFijosCollapsed] = useState(true);
  const [bloqueACollapsed, setBloqueACollapsed] = useState(true);
  const [bloqueBCollapsed, setBloqueBCollapsed] = useState(true);
  const [bloqueCCollapsed, setBloqueCCollapsed] = useState(true);
  const [bloqueDCollapsed, setBloqueDCollapsed] = useState(true);
  const [ebitCollapsed, setEbitCollapsed] = useState(true);
  const [resultadoCollapsed, setResultadoCollapsed] = useState(true);
  const [verEnDolares, setVerEnDolares] = useState(false);
  const [verChileYPeru, setVerChileYPeru] = useState(false);
  const [verUltimos12Meses, setVerUltimos12Meses] = useState(false);
  const [verAcumulados, setVerAcumulados] = useState(false);
  const [verUnitEconomics, setVerUnitEconomics] = useState(false);
  const [verInversionActivos, setVerInversionActivos] = useState(false);
  const [dtesSinVincular, setDtesSinVincular] = useState(0);
  const [siiVinculacionesMap, setSiiVinculacionesMap] = useState(null);
  const [editingFechaId, setEditingFechaId] = useState(null);
  const [editingFechaValue, setEditingFechaValue] = useState("");
  const [modalRefresh, setModalRefresh] = useState(0);
  const [costosHardwareFlex, setCostosHardwareFlex] = useState([]);
  const [selectedHardwareFlexMonth, setSelectedHardwareFlexMonth] = useState(null);
  const [isHardwareFlexModalOpen, setIsHardwareFlexModalOpen] = useState(false);
  const [nuevoCostoNegocioId, setNuevoCostoNegocioId] = useState(null);
  const [nuevoCostoMonto, setNuevoCostoMonto] = useState("");
  const [nuevoCostoTipo, setNuevoCostoTipo] = useState("compra_hardware");
  const [rawCostosFijos, setRawCostosFijos] = useState([]);
  // Estados para datos del año anterior (ventana 12 meses continuos)
  const [costosFijosDataAnoAnterior, setCostosFijosDataAnoAnterior] = useState([]);
  const [costosHardwareFlexAnoAnterior, setCostosHardwareFlexAnoAnterior] = useState([]);
  const [costosGestionDataAnoAnterior, setCostosGestionDataAnoAnterior] = useState([]);
  const [historiaER, setHistoriaER] = useState({
    2023: null,
    2024: null,
    2025: null,
    2026: null,
  });
  const [detalleHardwareIngresos, setDetalleHardwareIngresos] = useState(null);
  const [isHardwareIngresosModalOpen, setIsHardwareIngresosModalOpen] = useState(false);
  const [isChartModalOpen, setIsChartModalOpen] = useState(false);
  const [isAsesoriaModalOpen, setIsAsesoriaModalOpen] = useState(false);
  const [asesoriaUsd, setAsesoriaUsd] = useState(0);
  const [asesoriaFecha, setAsesoriaFecha] = useState("");
  const [asesoriaPreviewLocal, setAsesoriaPreviewLocal] = useState(0);
  const [editingAsesoriaMonthIndex, setEditingAsesoriaMonthIndex] = useState(null);
  const [isSoftwareDSModalOpenA, setIsSoftwareDSModalOpenA] = useState(false);
  const [editingSoftwareDSMonthIndexA, setEditingSoftwareDSMonthIndexA] = useState(null);
  const [softwareDSLicenciasA, setSoftwareDSLicenciasA] = useState(0);
  const [softwareDSPreviewLocalA, setSoftwareDSPreviewLocalA] = useState(0);
  const [isSoftwareDSModalOpenC, setIsSoftwareDSModalOpenC] = useState(false);
  const [editingSoftwareDSMonthIndexC, setEditingSoftwareDSMonthIndexC] = useState(null);
  const [softwareDSLicenciasC, setSoftwareDSLicenciasC] = useState(0);
  const [softwareDSPreviewLocalC, setSoftwareDSPreviewLocalC] = useState(0);
  const fechaHabilitacion2026 = new Date(2026, 1, 1);
  const es2026Habilitado = currentDate >= fechaHabilitacion2026;
  const [rrhhCollapsed, setRrhhCollapsed] = useState(true);
  const [inversionCollapsed, setInversionCollapsed] = useState(true);
  const [isVariosModalOpen, setIsVariosModalOpen] = useState(false);
  const [editingVariosMonthIndex, setEditingVariosMonthIndex] = useState(null);
  const [isInteresesModalOpen, setIsInteresesModalOpen] = useState(false);
  const [variosDetalleTemp, setVariosDetalleTemp] = useState([]);
  const [nuevoVariosConcepto, setNuevoVariosConcepto] = useState("");
  const [nuevoVariosMonto, setNuevoVariosMonto] = useState("");
  const [depreciacionMensual, setDepreciacionMensual] = useState(Array(12).fill(0));
  const [depreciacionMensualAnoAnterior, setDepreciacionMensualAnoAnterior] = useState(Array(12).fill(0));
  const [depreciacionMensualChile, setDepreciacionMensualChile] = useState(Array(12).fill(0));
  const [depreciacionMensualPeru, setDepreciacionMensualPeru] = useState(Array(12).fill(0));
  const [amortizacionMensual, setAmortizacionMensual] = useState(Array(12).fill(0));
  const [amortizacionMensualAnoAnterior, setAmortizacionMensualAnoAnterior] = useState(Array(12).fill(0));
  const [amortizacionMensualChile, setAmortizacionMensualChile] = useState(Array(12).fill(0));
  const [amortizacionMensualPeru, setAmortizacionMensualPeru] = useState(Array(12).fill(0));
  const [inversionMensual, setInversionMensual] = useState(Array(12).fill(0));
  const [inversionMensualAnoAnterior, setInversionMensualAnoAnterior] = useState(Array(12).fill(0));
  const [inversionMensualChile, setInversionMensualChile] = useState(Array(12).fill(0));
  const [inversionMensualPeru, setInversionMensualPeru] = useState(Array(12).fill(0));
  const [valorActivosMensual, setValorActivosMensual] = useState(Array(12).fill(0));
  const [valorActivosMensualAnoAnterior, setValorActivosMensualAnoAnterior] = useState(Array(12).fill(0));
  const [valorActivosMensualChile, setValorActivosMensualChile] = useState(Array(12).fill(0));
  const [valorActivosMensualPeru, setValorActivosMensualPeru] = useState(Array(12).fill(0));

  const { pais, id: userId, rol } = useAuthContext();
  const enteFiscal = pais === "Chile" ? "SII" : "SUNAT";

  // ─── Exchange rates (UF + dólar) ─────────────────────────────
  const {
    dolarMaps,
    dolarFallback,
    getDolarDia10,
    getUFValue,
    getDolarValue,
    getDolarValueChile,
    getDolarValuePeru,
    dolarMensual,
    dolarMensualAnoAnterior,
    dolarMensualChile,
    dolarMensualPeru,
    dolarMensualOtroPais,
  } = useExchangeRates(pais, selectedYear);

  // ─── Formatting (moneda, locale, currency) ───────────────────
  // En modo ventana: pasar dolar windowed y 12 meses a formatCurrency para conversión USD correcta
  const dolarMensualForFormatting = useMemo(
    () => (verUltimos12Meses ? windowArray(dolarMensual, dolarMensualAnoAnterior, monthsToShow) : dolarMensual),
    [verUltimos12Meses, dolarMensual, dolarMensualAnoAnterior, monthsToShow]
  );
  const {
    localString,
    moneda,
    getMoneda,
    formatCurrency: formatCurrencyBase,
    formatFee,
  } = useERFormatting(
    pais,
    verEnDolares,
    showInDollars,
    dolarMensualForFormatting,
    verUltimos12Meses ? 12 : monthsToShow,
    dolarFallback
  );

  // ─── RRHH (sueldos, beneficios, prorrateo) ────────────────────
  const {
    empleadosRRHH,
    isEmpleadosRRHHLoading,
    getSueldoBaseVigente,
    rrhhMensualConBeneficios,
    rrhhMensualConBeneficiosAnoAnterior,
    rrhhMensualChile,
    rrhhMensualPeru,
  } = useRRHHCalculations(pais, selectedYear, monthsToShow, empleadosRRHHChile, empleadosRRHHPeru);

  // Alias para compatibilidad con código existente (apunta al país de la sesión)
  const oportunidades = pais === "Chile" ? oportunidadesChile : oportunidadesPeru;
  const negociosCarteleria = pais === "Chile" ? negociosCarteleriaChile : negociosCarteleriaPeru;
  const salesBTL = pais === "Chile" ? salesBTLChile : salesBTLPeru;
  const salesBTLOtroPais = pais === "Chile" ? salesBTLPeru : salesBTLChile;
  const salesBTLAnoAnterior = pais === "Chile" ? salesBTLChileAnoAnterior : salesBTLPeruAnoAnterior;

  const esIdPermitido = userId && [1, 4, 7, 9].includes(Number(userId));
  const esRolPermitido = [ROLES.GERENCIA, ROLES.ADMINISTRATIVO].includes(rol);
  const puedeEditar = esIdPermitido && esRolPermitido;

  const logos = {
    Chile: wecastLogo,
    Perú: visionaLogo,
    Region: adigitalLogo,
  };

  // Logo base por país (se sobrescribe más adelante si es modo región)
  const logoPais = useMemo(() => logos[pais] || visionaLogo, [pais]);

  const getCostoGestionValue = useCallback(
    (monthIndex, field, negocioId = null) => {
      const mes = monthIndex + 1;
      const row = costosGestionData.find(
        (c) => Number(c.mes) === mes && Number(c.ano) === selectedYear && c.negocio_id === negocioId
      );
      return Number(row?.[field]) || 0;
    },
    [costosGestionData, selectedYear]
  );

  // Costos gestión AÑO ANTERIOR (para EBITDA Run Rate)
  const getCostoGestionValueAnoAnterior = useCallback(
    (monthIndex, field, negocioId = null) => {
      const mes = monthIndex + 1;
      const anoAnterior = selectedYear - 1;
      const row = costosGestionDataAnoAnterior.find(
        (c) => Number(c.mes) === mes && Number(c.ano) === anoAnterior && c.negocio_id === negocioId
      );
      return Number(row?.[field]) || 0;
    },
    [costosGestionDataAnoAnterior, selectedYear]
  );

  const convertirAMonedaLocal = useCallback(
    (valor, monedaOriginal, pais, negocioId = null, mes = null, ano = selectedYear, fechaUsadaOverride = null) => {
      if (!valor) return 0;
      const num = parseFloat(valor) || 0;
      const monedaUpper = monedaOriginal?.toUpperCase() || "";

      // UF solo Chile
      if (pais === "Chile" && monedaUpper.includes("UF")) {
        let fechaUsada = fechaUsadaOverride || null;
        if (!fechaUsada && negocioId && mes && ano) {
          const registro = costosGestionData.find(
            (c) =>
              parseInt(c.negocio_id) === parseInt(negocioId) &&
              parseInt(c.mes) === mes &&
              parseInt(c.ano) === ano &&
              c.fecha_factura
          );
          if (registro?.fecha_factura) fechaUsada = registro.fecha_factura.split("T")[0];
        }
        if (!fechaUsada && mes && ano) {
          const ultimoDia = new Date(ano, mes, 0);
          fechaUsada = ultimoDia.toISOString().split("T")[0];
        }
        if (!fechaUsada) fechaUsada = new Date().toISOString().split("T")[0];
        return Math.round(num * getUFValue(fechaUsada));
      }

      // US$ → convertir a local usando dólar observado
      if (monedaUpper === "US$" || monedaUpper === "USD") {
        let fechaUsada = fechaUsadaOverride || null;
        if (!fechaUsada && negocioId && mes && ano) {
          const registro = costosGestionData.find(
            (c) =>
              parseInt(c.negocio_id) === parseInt(negocioId) &&
              parseInt(c.mes) === mes &&
              parseInt(c.ano) === ano &&
              c.fecha_factura
          );
          if (registro?.fecha_factura) fechaUsada = registro.fecha_factura.split("T")[0];
        }
        if (!fechaUsada && mes) {
          fechaUsada = `${ano}-${String(mes).padStart(2, "0")}-01`; // día 1 si no hay fecha
        }
        if (!fechaUsada) fechaUsada = new Date().toISOString().split("T")[0];
        const dolar = getDolarValue(fechaUsada);
        return Math.round(num * dolar);
      }

      // Moneda local o cualquier otra → directo
      return Math.round(num);
    },
    [costosGestionData, currentYear, getUFValue, getDolarValue]
  );

  // Flag para modo combinado
  const modoCombinado = verChileYPeru && datosCombinadosCargados;

  const {
    getProjectedCostoFijo,
    getCostoFijoValor,
    costosFijosMensualAnoAnterior,
    sumarCostosFijosMes,
    costosFijosYTD,
    costosFijosMensualesCombinados,
  } = useCostosFijosCalcs({
    costosFijosData,
    costosFijosDataAnoAnterior,
    costosFijosChile,
    costosFijosPeru,
    rawCostosFijos,
    rawCostosFijosChile,
    rawCostosFijosPeru,
    selectedYear,
    monthsToShow,
    modoCombinado,
    pais,
    getDolarDia10,
    dolarMaps,
    dolarMensualChile,
    dolarMensualPeru,
    rrhhMensualConBeneficios,
    rrhhMensualChile,
    rrhhMensualPeru,
    rrhhMensualConBeneficiosAnoAnterior,
    dolarFallback,
    costosFijosChileAnoAnterior,
    costosFijosPeruAnoAnterior,
  });

  // Logo: usa region-logo cuando está en modo combinado
  const logo = modoCombinado ? regionLogo : logoPais;

  // Cargar oportunidades de AMBOS países al inicio
  useEffect(() => {
    // Siempre cargar ambos países
    const fetchData = async () => {
      try {
        setIsOportunidadesLoading(true);
        // Garantiza tipos de cambio cargados antes de calculos YoY/conversiones.
        await loadExchangeRates();
        // Cargar ambos países en paralelo (oportunidades + contratos)
        const [oppsChile, oppsPeru, ctChile, ctPeru] = await Promise.all([
          getOportunidades({ pais: "Chile" }),
          getOportunidades({ pais: "Perú" }),
          getContratos({ pais: "Chile" }),
          getContratos({ pais: "Perú" }),
        ]);
        const filteredChile = oppsChile.filter((o) => o.pais === "Chile");
        const filteredPeru = oppsPeru.filter((o) => o.pais === "Perú");
        setOportunidadesChile(filteredChile);
        setOportunidadesPeru(filteredPeru);
        setContratosChile(ctChile || []);
        setContratosPeru(ctPeru || []);
      } catch (err) {
        console.error("Error cargando oportunidades:", err);
      } finally {
        setIsOportunidadesLoading(false);
      }
    };
    // Solo cargar si no tenemos datos
    if (oportunidadesChile.length === 0 || oportunidadesPeru.length === 0) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cargar clientes e intermediarios de AMBOS países al inicio
  useEffect(() => {
    const fetchClientesAmbos = async () => {
      try {
        const [clientesChileData, clientesPeruData] = await Promise.all([
          getClientes({ pais: "Chile" }),
          getClientes({ pais: "Perú" }),
        ]);
        const mapChile = (clientesChileData || []).reduce((acc, c) => {
          if (c.id) acc[c.id] = { ...c, agencia: c.agencia || null };
          return acc;
        }, {});
        const mapPeru = (clientesPeruData || []).reduce((acc, c) => {
          if (c.id) acc[c.id] = { ...c, agencia: c.agencia || null };
          return acc;
        }, {});
        setClientesChile(mapChile);
        setClientesPeru(mapPeru);
      } catch (err) {
        console.error("Error cargando clientes ambos países:", err);
      }
    };

    const fetchIntermediariosAmbos = async () => {
      try {
        const [intChile, intPeru] = await Promise.all([
          getIntermediarios({ pais: "Chile" }),
          getIntermediarios({ pais: "Perú" }),
        ]);
        const mapChile = (intChile || []).reduce((acc, i) => {
          if (i.id) acc[i.id] = i;
          return acc;
        }, {});
        const mapPeru = (intPeru || []).reduce((acc, i) => {
          if (i.id) acc[i.id] = i;
          return acc;
        }, {});
        setIntermediariosChile(mapChile);
        setIntermediariosPeru(mapPeru);
      } catch (err) {
        console.error("Error cargando intermediarios:", err);
      }
    };

    const fetchEdificiosAmbos = async () => {
      try {
        const [edificiosChileData, edificiosPeruData, snapChile, snapPeru, costosChile, costosPeru] = await Promise.all(
          [
            getEdificios({ pais: "Chile" }),
            getEdificios({ pais: "Perú" }),
            cargarSnapshotDenominadores("Chile").catch(() => null),
            cargarSnapshotDenominadores("Perú").catch(() => null),
            cargarCostosIntermediacion("Chile").catch(() => null),
            cargarCostosIntermediacion("Perú").catch(() => null),
          ]
        );
        const mapChile = (edificiosChileData || []).reduce((acc, e) => {
          if (e.id) acc[e.id] = e;
          return acc;
        }, {});
        const mapPeru = (edificiosPeruData || []).reduce((acc, e) => {
          if (e.id) acc[e.id] = e;
          return acc;
        }, {});
        setEdificiosChile(mapChile);
        setEdificiosPeru(mapPeru);
        setSnapMapChile(snapChile);
        setSnapMapPeru(snapPeru);
        setCostosMapChile(costosChile);
        setCostosMapPeru(costosPeru);
      } catch (err) {
        console.error("Error cargando edificios ambos países:", err);
      }
    };

    const fetchCostosPublicidadAmbos = async () => {
      try {
        const [cpChile, cpPeru, cpChileAA, cpPeruAA] = await Promise.all([
          getCostosPublicidad({ pais: "Chile", ano: selectedYear }),
          getCostosPublicidad({ pais: "Perú", ano: selectedYear }),
          getCostosPublicidad({ pais: "Chile", ano: selectedYear - 1 }),
          getCostosPublicidad({ pais: "Perú", ano: selectedYear - 1 }),
        ]);
        // Normalizar campo por campo: null = proyectar, número = valor real
        const normalizeCP = (rawData) =>
          Array(12)
            .fill(null)
            .map((_, index) => {
              const row = rawData?.[index];
              if (!row) return null;
              return {
                servicios_internet: row.servicios_internet == null ? null : Number(row.servicios_internet),
                software_ds: row.software_ds == null ? null : Number(row.software_ds),
                mantenimiento: row.mantenimiento == null ? null : Number(row.mantenimiento),
              };
            });
        setCostosPublicidadChile(normalizeCP(cpChile));
        setCostosPublicidadPeru(normalizeCP(cpPeru));
        setCostosPublicidadChileAA(normalizeCP(cpChileAA));
        setCostosPublicidadPeruAA(normalizeCP(cpPeruAA));
      } catch (err) {
        console.error("Error cargando costos publicidad ambos países:", err);
      }
    };

    const fetchCostosGestionAmbos = async () => {
      try {
        const [cgChile, cgPeru, cgChileAA, cgPeruAA] = await Promise.all([
          getCostosGestion({ pais: "Chile", ano: selectedYear }),
          getCostosGestion({ pais: "Perú", ano: selectedYear }),
          getCostosGestion({ pais: "Chile", ano: selectedYear - 1 }),
          getCostosGestion({ pais: "Perú", ano: selectedYear - 1 }),
        ]);
        setCostosGestionChile(cgChile || []);
        setCostosGestionPeru(cgPeru || []);
        setCostosGestionChileAA(cgChileAA || []);
        setCostosGestionPeruAA(cgPeruAA || []);
      } catch (err) {
        console.error("Error cargando costos gestión ambos países:", err);
      }
    };

    fetchClientesAmbos();
    fetchIntermediariosAmbos();
    fetchEdificiosAmbos();
    fetchCostosPublicidadAmbos();
    fetchCostosGestionAmbos();
  }, [selectedYear]);

  // Cargar datos complementarios del otro país cuando se activa modo combinado
  // (oportunidades, negocios y BTL ya se cargan al inicio; dólar ya se carga en useExchangeRates)
  useEffect(() => {
    if (!verChileYPeru || datosCombinadosCargados) return;

    const otroPais = pais === "Chile" ? "Perú" : "Chile";

    const fetchDatosOtroPais = async () => {
      try {
        // Costos fijos del otro país
        const cfOtro = await getCostosFijos({ pais: otroPais, ano: selectedYear });
        setCostosFijosOtroPais(cfOtro || []);

        setDatosCombinadosCargados(true);
      } catch (err) {
        console.error("Error cargando datos del otro país:", err);
      }
    };

    fetchDatosOtroPais();
  }, [verChileYPeru, datosCombinadosCargados, pais, selectedYear]);

  // Reset datos combinados cuando cambia el año
  useEffect(() => {
    setDatosCombinadosCargados(false);
  }, [selectedYear]);

  // Contar DTEs SII sin vincular del año seleccionado
  useEffect(() => {
    const fetchDTEsPendientes = async () => {
      try {
        const desde = `${selectedYear}-01-01`;
        const hasta = `${selectedYear}-12-31`;
        const [emRes, recRes] = await Promise.all([
          client
            .from("facturas_sii_emitidas")
            .select("id", { count: "exact", head: true })
            .eq("pais", pais)
            .eq("estado_vinculacion", "pendiente")
            .gte("fecha_emision", desde)
            .lte("fecha_emision", hasta),
          client
            .from("facturas_sii_recibidas")
            .select("id", { count: "exact", head: true })
            .eq("pais", pais)
            .eq("estado_vinculacion", "pendiente")
            .gte("fecha_emision", desde)
            .lte("fecha_emision", hasta),
        ]);
        setDtesSinVincular((emRes.count || 0) + (recRes.count || 0));
      } catch {
        /* silenciar si las tablas no existen aún */
      }
    };
    if (pais && pais !== "Region") fetchDTEsPendientes();
  }, [pais, selectedYear]);

  // Cargar mapa de vinculaciones SII para detectar ventas sin DTE vinculado
  useEffect(() => {
    const fetchSiiVinculaciones = async () => {
      try {
        const { data } = await client
          .from("facturas_sii_emitidas")
          .select("folio, id, facturas_sii_vinculaciones(venta_tipo, venta_ref_id, venta_ref_index)")
          .eq("pais", pais)
          .eq("estado_vinculacion", "vinculada");
        const map = { _byRef: {} };
        (data || []).forEach((f) => {
          map[String(f.folio)] = { facturaId: f.id };
          (f.facturas_sii_vinculaciones || []).forEach((v) => {
            const key = `${v.venta_tipo}:${v.venta_ref_id}:${v.venta_ref_index ?? ""}`;
            map._byRef[key] = { facturaId: f.id, folio: f.folio };
          });
        });
        setSiiVinculacionesMap(map);
      } catch {
        setSiiVinculacionesMap({ _byRef: {} });
      }
    };
    if (pais && pais !== "Region") fetchSiiVinculaciones();
    else setSiiVinculacionesMap({ _byRef: {} });
  }, [pais]);

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setIsClientesLoading(true);
        const clientesData = await getClientes({ pais });
        if (!clientesData || clientesData.length === 0) {
          console.error("No clientes data returned for pais:", pais);
          return;
        }
        const clientesMap = clientesData.reduce((acc, cliente) => {
          if (!cliente.id) {
            console.warn("Cliente without id:", cliente);
            return acc;
          }
          acc[cliente.id] = { ...cliente, agencia: cliente.agencia || null };
          return acc;
        }, {});
        setClientes(clientesMap);
      } catch (error) {
        console.error("Error fetching clientes:", error);
      } finally {
        setIsClientesLoading(false);
      }
    };
    fetchClientes();
  }, [pais]);

  useEffect(() => {
    const fetchDepreciacionYAmortizacion = async () => {
      try {
        const actual = await getDepreciacionYAmortizacion(pais, selectedYear);
        setDepreciacionMensual(actual.depreciacion);
        setAmortizacionMensual(actual.amortizacion);
        const anterior = await getDepreciacionYAmortizacion(pais, selectedYear - 1);
        setDepreciacionMensualAnoAnterior(anterior.depreciacion);
        setAmortizacionMensualAnoAnterior(anterior.amortizacion);
        // Cargar ambos países para modo combinado
        const chile = await getDepreciacionYAmortizacion("Chile", selectedYear);
        const peru = await getDepreciacionYAmortizacion("Perú", selectedYear);
        setDepreciacionMensualChile(chile.depreciacion);
        setDepreciacionMensualPeru(peru.depreciacion);
        setAmortizacionMensualChile(chile.amortizacion);
        setAmortizacionMensualPeru(peru.amortizacion);
      } catch (error) {
        console.error("Error fetching depreciación/amortización:", error);
      }
    };
    fetchDepreciacionYAmortizacion();
  }, [pais, selectedYear]);

  useEffect(() => {
    const fetchInversion = async () => {
      try {
        const inv = await getInversionMensual(pais, selectedYear);
        setInversionMensual(inv);
        const invAA = await getInversionMensual(pais, selectedYear - 1);
        setInversionMensualAnoAnterior(invAA);
        const invChile = await getInversionMensual("Chile", selectedYear);
        const invPeru = await getInversionMensual("Perú", selectedYear);
        setInversionMensualChile(invChile);
        setInversionMensualPeru(invPeru);
      } catch (error) {
        console.error("Error fetching inversión:", error);
      }
    };
    fetchInversion();
  }, [pais, selectedYear]);

  useEffect(() => {
    const fetchValorActivos = async () => {
      try {
        const val = await getValorActivosMensual(pais, selectedYear);
        setValorActivosMensual(val);
        const valAA = await getValorActivosMensual(pais, selectedYear - 1);
        setValorActivosMensualAnoAnterior(valAA);
        const valChile = await getValorActivosMensual("Chile", selectedYear);
        const valPeru = await getValorActivosMensual("Perú", selectedYear);
        setValorActivosMensualChile(valChile);
        setValorActivosMensualPeru(valPeru);
      } catch (error) {
        console.error("Error fetching valor activos:", error);
      }
    };
    fetchValorActivos();
  }, [pais, selectedYear]);

  useEffect(() => {
    const fetchEdificios = async () => {
      try {
        const edificiosData = await getEdificios({ pais });
        if (!edificiosData || edificiosData.length === 0) {
          setEdificios({});
          return;
        }
        const edificiosMap = edificiosData.reduce((acc, edificio) => {
          acc[edificio.id] = edificio; // ← TODO EL OBJETO
          return acc;
        }, {});
        setEdificios(edificiosMap);
        const snap = await cargarSnapshotDenominadores(pais).catch(() => null);
        setSnapMap(snap);
        const costos = await cargarCostosIntermediacion(pais).catch(() => null);
        setCostosMap(costos);
      } catch (error) {
        console.error("Error fetching edificios:", error);
        setEdificios({});
      }
    };
    fetchEdificios();
  }, [pais]);

  useEffect(() => {
    const fetchIntermediarios = async () => {
      try {
        const intermediariosData = await getIntermediarios({ pais });
        const intermediariosMap = intermediariosData.reduce((acc, intermediario) => {
          acc[intermediario.id] = intermediario;
          return acc;
        }, {});
        setIntermediarios(intermediariosMap);
      } catch {
        // Silently ignore errors
      }
    };
    fetchIntermediarios();
  }, [pais]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersData = await getUsers();
        const usersMap = usersData.reduce((acc, user) => {
          acc[user.id] = user.nombre || `User ${user.id}`;
          return acc;
        }, {});
        setUsers(usersMap);
      } catch {
        // Silently ignore errors
      }
    };
    fetchUsers();
  }, []);

  // CARGA DE COSTOS GESTIÓN Y CONTENIDOS (C) – NORMALIZADO Y SEGURO (año actual y anterior)
  useEffect(() => {
    const fetch = async () => {
      try {
        const queryActual = client
          .from("costos_gestion_contenidos")
          .select("*")
          .eq("pais", pais)
          .eq("ano", selectedYear);
        const queryAnterior = client
          .from("costos_gestion_contenidos")
          .select("*")
          .eq("pais", pais)
          .eq("ano", selectedYear - 1);
        const [rawData, rawDataAnoAnterior] = await Promise.all([queryActual, queryAnterior]);
        setCostosGestionData(rawData.data || []);
        setCostosGestionDataAnoAnterior(rawDataAnoAnterior.data || []);
      } catch (err) {
        console.error("Error cargando costos gestión:", err);
        setCostosGestionData([]);
        setCostosGestionDataAnoAnterior([]);
      }
    };
    if (pais && selectedYear) fetch();
  }, [pais, selectedYear]);

  // Cargar negocios cartelería de AMBOS países al inicio
  useEffect(() => {
    if (negociosCarteleriaChile.length > 0 && negociosCarteleriaPeru.length > 0) return;
    const fetchNegocios = async () => {
      try {
        // Cargar ambos países en paralelo
        const [resChile, resPeru] = await Promise.all([
          client.from("negocios_carteleria").select("*").eq("pais", "Chile").neq("eliminada", true),
          client.from("negocios_carteleria").select("*").eq("pais", "Perú").neq("eliminada", true),
        ]);

        if (resChile.error) throw resChile.error;
        if (resPeru.error) throw resPeru.error;

        setNegociosCarteleriaChile(resChile.data || []);
        setNegociosCarteleriaPeru(resPeru.data || []);
      } catch {
        toast.error("Error cargando negocios de cartelería");
      }
    };

    fetchNegocios();
  }, [negociosCarteleriaChile.length, negociosCarteleriaPeru.length]);

  // CARGA DE COSTOS DE PUBLICIDAD (A) – FIX DEFINITIVO
  useEffect(() => {
    const fetch = async () => {
      try {
        // Cargar año actual y año anterior en paralelo
        const [rawData, rawDataAnoAnterior] = await Promise.all([
          getCostosPublicidad({ pais, ano: selectedYear }),
          getCostosPublicidad({ pais, ano: selectedYear - 1 }),
        ]);

        // Función para normalizar datos de publicidad (campo por campo)
        // null = sin dato (proyectar), número = valor real (incluso 0)
        const normalizarPublicidad = (data) =>
          Array(12)
            .fill(null)
            .map((_, index) => {
              const row = data?.[index];
              if (!row) return null;
              // Mantener null si el campo es null, convertir a número si tiene valor
              return {
                servicios_internet: row.servicios_internet == null ? null : Number(row.servicios_internet),
                software_ds: row.software_ds == null ? null : Number(row.software_ds),
                mantenimiento: row.mantenimiento == null ? null : Number(row.mantenimiento),
              };
            });

        setCostosPublicidadData(normalizarPublicidad(rawData));
        setCostosPublicidadDataAnoAnterior(normalizarPublicidad(rawDataAnoAnterior));
      } catch (err) {
        console.error("Error cargando costos publicidad:", err);
        setCostosPublicidadData(Array(12).fill(null));
        setCostosPublicidadDataAnoAnterior(Array(12).fill(null));
      }
    };

    if (pais && selectedYear) fetch();
  }, [pais, selectedYear, monthsToShow]);

  // CARGA DE COSTOS HARDWARE – NORMALIZADO Y SEGURO (año actual y anterior)
  useEffect(() => {
    if (!pais || !selectedYear) return;

    const fetch = async () => {
      const [data, dataAnoAnterior] = await Promise.all([
        getCostosHardwareFlex({ pais, ano: selectedYear }),
        getCostosHardwareFlex({ pais, ano: selectedYear - 1 }),
      ]);
      setCostosHardwareFlex(data || []);
      setCostosHardwareFlexAnoAnterior(dataAnoAnterior || []);
    };

    fetch();
  }, [pais, selectedYear]);

  useEffect(() => {
    const fetch = async () => {
      try {
        // Cargar año actual y año anterior en paralelo
        const [raw, rawAnoAnterior] = await Promise.all([
          getCostosFijos({ pais, ano: selectedYear }),
          getCostosFijos({ pais, ano: selectedYear - 1 }),
        ]);
        setRawCostosFijos(raw || []);

        // Normalizar año actual
        const normalized = Array(12)
          .fill(null)
          .map((_, i) => {
            const row = raw?.find((r) => Number(r.mes) === i + 1);
            const mesData = {};
            camposCostosFijos.forEach((campo) => {
              mesData[campo] = Number(row?.[campo]) || 0;
            });
            // Agregar campos extras de asesoría externa
            mesData.asesoria_externa_usd = Number(row?.asesoria_externa_usd) || 0;
            mesData.asesoria_externa_fecha = row?.asesoria_externa_fecha || null;
            mesData.varios_detalle = row?.varios_detalle || [];
            return mesData;
          });
        setCostosFijosData(normalized);

        // Normalizar año anterior
        const normalizedAnoAnterior = Array(12)
          .fill(null)
          .map((_, i) => {
            const row = rawAnoAnterior?.find((r) => Number(r.mes) === i + 1);
            const mesData = {};
            camposCostosFijos.forEach((campo) => {
              mesData[campo] = Number(row?.[campo]) || 0;
            });
            return mesData;
          });
        setCostosFijosDataAnoAnterior(normalizedAnoAnterior);
      } catch (err) {
        console.error("Error cargando costos fijos:", err);
        setCostosFijosData(
          Array(12).fill({
            contador: 0,
            oficina: 0,
            transporte: 0,
            telefonia: 0,
            marketing: 0,
            gastos_representacion: 0,
            alojamiento: 0,
            viajes_gerencia: 0,
            gastos_bancarios: 0,
            varios: 0,
          })
        );
        setCostosFijosDataAnoAnterior(Array(12).fill({}));
      }
    };
    if (pais && selectedYear) fetch();
  }, [pais, selectedYear, monthsToShow]);

  // Cargar salesBTL de AMBOS países al inicio
  useEffect(() => {
    if (salesBTLChile.length > 0 && salesBTLPeru.length > 0) return;

    const fetchBTL = async () => {
      try {
        // Cargar ambos países en paralelo
        const [resChile, resPeru] = await Promise.all([
          client.from("sales_btl").select("*").eq("pais", "Chile").eq("eliminada", false),
          client.from("sales_btl").select("*").eq("pais", "Perú").eq("eliminada", false),
        ]);

        if (resChile.error) throw resChile.error;
        if (resPeru.error) throw resPeru.error;

        // Filtrar por año seleccionado y año anterior
        const anoAnterior = selectedYear - 1;
        const filteredChile = (resChile.data || []).filter((row) => {
          if (!row.facturafecha) return false;
          return new Date(row.facturafecha).getFullYear() === selectedYear;
        });
        const filteredPeru = (resPeru.data || []).filter((row) => {
          if (!row.facturafecha) return false;
          return new Date(row.facturafecha).getFullYear() === selectedYear;
        });
        const filteredChileAnoAnterior = (resChile.data || []).filter((row) => {
          if (!row.facturafecha) return false;
          return new Date(row.facturafecha).getFullYear() === anoAnterior;
        });
        const filteredPeruAnoAnterior = (resPeru.data || []).filter((row) => {
          if (!row.facturafecha) return false;
          return new Date(row.facturafecha).getFullYear() === anoAnterior;
        });

        setSalesBTLChile(filteredChile);
        setSalesBTLPeru(filteredPeru);
        setSalesBTLChileAnoAnterior(filteredChileAnoAnterior);
        setSalesBTLPeruAnoAnterior(filteredPeruAnoAnterior);
      } catch (err) {
        console.error("Error cargando sales_btl:", err);
        setSalesBTLChile([]);
        setSalesBTLPeru([]);
      }
    };

    fetchBTL();
  }, [selectedYear, salesBTLChile.length, salesBTLPeru.length]);

  // Cargar costos fijos y empleados de AMBOS países (para modo combinado)
  useEffect(() => {
    const fetchCostosFijosAmbos = async () => {
      try {
        const [cfChile, cfPeru, cfChileAA, cfPeruAA] = await Promise.all([
          getCostosFijos({ pais: "Chile", ano: selectedYear }),
          getCostosFijos({ pais: "Perú", ano: selectedYear }),
          getCostosFijos({ pais: "Chile", ano: selectedYear - 1 }),
          getCostosFijos({ pais: "Perú", ano: selectedYear - 1 }),
        ]);

        // Guardar datos raw para proyecciones
        setRawCostosFijosChile(cfChile || []);
        setRawCostosFijosPeru(cfPeru || []);

        // Normalizar costos fijos Chile (incluir asesoria_externa_usd para modo combinado)
        const normChile = Array(12)
          .fill(null)
          .map((_, i) => {
            const row = cfChile?.find((r) => Number(r.mes) === i + 1);
            const mesData = {};
            camposCostosFijos.forEach((campo) => {
              mesData[campo] = Number(row?.[campo]) || 0;
            });
            // Campos extras para asesoría externa en USD
            mesData.asesoria_externa_usd = Number(row?.asesoria_externa_usd) || 0;
            return mesData;
          });
        setCostosFijosChile(normChile);

        // Normalizar costos fijos Perú (incluir asesoria_externa_usd para modo combinado)
        const normPeru = Array(12)
          .fill(null)
          .map((_, i) => {
            const row = cfPeru?.find((r) => Number(r.mes) === i + 1);
            const mesData = {};
            camposCostosFijos.forEach((campo) => {
              mesData[campo] = Number(row?.[campo]) || 0;
            });
            // Campos extras para asesoría externa en USD
            mesData.asesoria_externa_usd = Number(row?.asesoria_externa_usd) || 0;
            return mesData;
          });
        setCostosFijosPeru(normPeru);

        // Normalizar año anterior Chile
        const normChileAA = Array(12)
          .fill(null)
          .map((_, i) => {
            const row = cfChileAA?.find((r) => Number(r.mes) === i + 1);
            const mesData = {};
            camposCostosFijos.forEach((campo) => {
              mesData[campo] = Number(row?.[campo]) || 0;
            });
            return mesData;
          });
        setCostosFijosChileAnoAnterior(normChileAA);

        // Normalizar año anterior Perú
        const normPeruAA = Array(12)
          .fill(null)
          .map((_, i) => {
            const row = cfPeruAA?.find((r) => Number(r.mes) === i + 1);
            const mesData = {};
            camposCostosFijos.forEach((campo) => {
              mesData[campo] = Number(row?.[campo]) || 0;
            });
            return mesData;
          });
        setCostosFijosPeruAnoAnterior(normPeruAA);
      } catch (err) {
        console.error("Error cargando costos fijos ambos países:", err);
      }
    };

    const fetchEmpleadosAmbos = async () => {
      try {
        const [empChile, empPeru] = await Promise.all([getEmpleados("Chile"), getEmpleados("Perú")]);

        // Cargar remuneraciones para Chile
        const empChileConRem = await Promise.all(
          empChile.map(async (emp) => {
            const rems = await getRemuneracionesEmpleado(emp.id);
            return { ...emp, remuneraciones: rems || [] };
          })
        );
        setEmpleadosRRHHChile(empChileConRem);

        // Cargar remuneraciones para Perú
        const empPeruConRem = await Promise.all(
          empPeru.map(async (emp) => {
            const rems = await getRemuneracionesEmpleado(emp.id);
            return { ...emp, remuneraciones: rems || [] };
          })
        );
        setEmpleadosRRHHPeru(empPeruConRem);
      } catch (err) {
        console.error("Error cargando empleados ambos países:", err);
      }
    };

    const fetchCostosHardwareAmbos = async () => {
      try {
        const [hwChile, hwPeru] = await Promise.all([
          getCostosHardwareFlex({ pais: "Chile", ano: selectedYear }),
          getCostosHardwareFlex({ pais: "Perú", ano: selectedYear }),
        ]);
        setCostosHardwareFlexChile(hwChile || []);
        setCostosHardwareFlexPeru(hwPeru || []);
      } catch (err) {
        console.error("Error cargando costos hardware ambos países:", err);
      }
    };

    if (selectedYear) {
      fetchCostosFijosAmbos();
      fetchEmpleadosAmbos();
      fetchCostosHardwareAmbos();
    }
  }, [selectedYear]);

  // D - BTL y otros
  const {
    ingresosBTLMensual,
    ingresosBTLMensualAnoAnterior,
    ingresosBTLMensualChile,
    ingresosBTLMensualPeru,
    comisionEdificiosBTLMensual,
    comisionEdificiosBTLMensualAnoAnterior,
    comisionEdificiosBTLMensualChile,
    comisionEdificiosBTLMensualPeru,
    otrosCostosBTLMensual,
    otrosCostosBTLMensualAnoAnterior,
    otrosCostosBTLMensualChile,
    otrosCostosBTLMensualPeru,
    margenBTLMensual,
    ytdIngresosBTL,
    ytdComisionEdificiosBTL,
    ytdOtrosCostosBTL,
    ytdMargenBTL,
  } = useBTLCalcs({
    salesBTL,
    salesBTLAnoAnterior,
    salesBTLChile,
    salesBTLPeru,
    salesBTLOtroPais,
    selectedYear,
    monthsToShow,
    modoCombinado,
  });

  // E - Contratos multi-mes (ingresos + comisiones edificios/agencia/comercial)
  const {
    ingresosContratosMensual,
    ingresosContratosMensualAnoAnterior,
    contratosMensualesCombinados,
    comisionEdificiosContratosMensual,
    comisionEdificiosContratosMensualAnoAnterior,
    comisionEdificiosContratosMensualChile,
    comisionEdificiosContratosMensualPeru,
    comisionAgenciaContratosMensual,
    comisionAgenciaContratosMensualAnoAnterior,
    comisionAgenciaContratosMensualChile,
    comisionAgenciaContratosMensualPeru,
    comisionBrokerContratosMensual,
    comisionBrokerContratosMensualAnoAnterior,
    comisionBrokerContratosMensualChile,
    comisionBrokerContratosMensualPeru,
    comisionesAgenciaContratosPorMes,
    comisionesBrokerContratosPorMes,
    comisionApxContratosMensual,
    comisionApxContratosMensualAnoAnterior,
    comisionApxContratosMensualChile,
    comisionApxContratosMensualPeru,
    apxContratosPorMes,
    comisionComercialContratosMensual,
    comisionComercialContratosMensualAnoAnterior,
    comisionComercialContratosMensualChile,
    comisionComercialContratosMensualPeru,
    facturasPorMesContratos,
    comisionesEdificiosPorMesContratos,
  } = useContratosCalcs({
    contratosChile,
    contratosPeru,
    selectedYear,
    modoCombinado,
    dolarFallback,
    getDolarValue,
    getDolarValueChile,
    getDolarValuePeru,
    dolarMensualChile,
    dolarMensualPeru,
    pais,
    edificios,
    edificiosChile,
    edificiosPeru,
    snapMap,
    snapMapChile,
    snapMapPeru,
    clientes,
    clientesChile,
    clientesPeru,
    intermediarios,
    intermediariosChile,
    intermediariosPeru,
  });

  const getProjectedValue = useCallback(
    (concept, month) => {
      if (conceptosManuales.includes(concept)) {
        const fieldMap = {
          "Servicios internet": "servicios_internet",
          "Software DS": "software_ds",
          Mantenimiento: "mantenimiento",
        };
        const field = fieldMap[concept];
        const monthIndex = month - 1; // month viene 1-12, convertir a 0-11
        const valores12Meses = [];

        // Primero: meses del año actual (desde enero hasta el mes anterior al proyectado)
        for (let i = 0; i < monthIndex; i++) {
          const row = costosPublicidadData[i];
          if (row && row[field] !== null && row[field] !== undefined) {
            const val = Number(row[field]) || 0;
            if (val > 0) valores12Meses.push(val);
          }
        }

        // Segundo: meses del año anterior (desde diciembre hacia atrás para completar 12)
        if (costosPublicidadDataAnoAnterior.length > 0) {
          for (let i = 11; i >= 0 && valores12Meses.length < 12; i--) {
            const row = costosPublicidadDataAnoAnterior[i];
            if (row && row[field] !== null && row[field] !== undefined) {
              const val = Number(row[field]) || 0;
              if (val > 0) valores12Meses.push(val);
            }
          }
        }

        if (valores12Meses.length === 0) return 0;
        return Math.round(valores12Meses.reduce((a, b) => a + b, 0) / valores12Meses.length);
      }
      // Solo "Otros" del bloque C
      if (concept === "Otros") {
        const values = meses.map((_, i) => {
          const m = i + 1;
          const row = costosGestionData.find((c) => parseInt(c.mes, 10) === m && Number(c.ano) === selectedYear);
          if (!row) return null;
          const val = Number(row.otros) || 0;
          return val > 0 ? val : null;
        });
        const validValues = values.filter((v) => v !== null);
        if (validValues.length === 0) return 0;
        return Math.round(validValues.reduce((a, b) => a + b, 0) / validValues.length);
      }
      return 0;
    },
    [costosPublicidadData, costosPublicidadDataAnoAnterior, costosGestionData, selectedYear, conceptosManuales]
  );

  // ─── Gestión / Bloque C (cartelería, software DS, contenidos) ─
  const {
    detalleGestionContenidosPorMes,
    calcularCostoSoftwareEstimado,
    getSoftwareDSValueA,
    getFechaFacturaHardware,
    ingresosGestionContenidosMensual,
    ingresosGestionContenidosMensualAnoAnterior,
    gestionMensualesCombinados,
    ytdSoftwareDS,
    ytdOtros,
    margenGestionContenidosMensual,
    ytdMargenGestionContenidos,
    ytdIngresosGestionContenidos,
  } = useGestionCalcs({
    pais,
    selectedYear,
    monthsToShow,
    currentYear,
    modoCombinado,
    negociosCarteleria,
    negociosCarteleriaChile,
    negociosCarteleriaPeru,
    clientes,
    edificios,
    costosGestionData,
    costosPublicidadData,
    convertirAMonedaLocal,
    getCostoGestionValue,
    getDolarValue,
    dolarMensualPeru,
    dolarMensualChile,
    dolarFallback,
    modalRefresh,
  });

  const getValueForMonth = useCallback(
    (concept, month) => {
      if (month > monthsToShow + 1) {
        return { value: 0, isProjected: false };
      }
      let value = 0;
      let isProjected = true;

      // === Publicidad ===
      if (conceptosManuales.includes(concept)) {
        const fieldMap = {
          "Servicios internet": "servicios_internet",
          "Software DS": "software_ds",
          Mantenimiento: "mantenimiento",
        };
        const field = fieldMap[concept];
        const row = costosPublicidadData[month - 1];
        if (row === null || row === undefined) {
          isProjected = true;
        } else if (row[field] === null || row[field] === undefined) {
          isProjected = true;
        } else {
          value = concept === "Software DS" ? getSoftwareDSValueA(month - 1) : row[field];
          isProjected = false;
        }
      }
      // === Gestión y Contenidos ===
      else if (["Software DS", "Otros"].includes(concept)) {
        const field = concept === "Software DS" ? "software_ds" : "otros";
        const row = costosGestionData.find((c) => parseInt(c.mes, 10) === month);
        if (row !== undefined) {
          value = Number(row[field]) || 0;
          isProjected = false;
        }
      }

      // Si no hay fila → proyectar
      if (isProjected) {
        value = getProjectedValue(concept, month);
      }

      return { value, isProjected };
    },
    [costosPublicidadData, costosGestionData, monthsToShow, getProjectedValue, conceptosManuales, getSoftwareDSValueA]
  );

  const getYTDManual = useCallback(
    (concept) => meses.slice(0, monthsToShow).reduce((acc, _, i) => acc + getValueForMonth(concept, i + 1).value, 0),
    [getValueForMonth, monthsToShow]
  );

  const showInvoiceModal = (index) => {
    if (index < monthsToShow) {
      setSelectedMonth(index);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMonth(null);
  };

  const showBuildingCommissionModal = (index) => {
    if (index < monthsToShow) {
      setSelectedBuildingCommissionMonth(index);
      setIsBuildingCommissionModalOpen(true);
    }
  };

  const closeAgencyModal = () => {
    setIsAgencyModalOpen(false);
    setSelectedAgencyMonth(null);
  };

  const closeCommercialModal = () => {
    setIsCommercialModalOpen(false);
    setSelectedCommercialMonth(null);
  };

  const closeBuildingCommissionModal = () => {
    setIsBuildingCommissionModalOpen(false);
    setSelectedBuildingCommissionMonth(null);
  };

  const openHardwareFlexModal = async (monthIndex) => {
    if (monthIndex >= monthsToShow) {
      toast("Solo meses pasados");
      return;
    }
    setSelectedHardwareFlexMonth(monthIndex);
    setIsHardwareFlexModalOpen(true);
  };

  const closeHardwareFlexModal = () => {
    setIsHardwareFlexModalOpen(false);
    setSelectedHardwareFlexMonth(null);
    // Recargamos datos frescos desde la nueva tabla
    getCostosHardwareFlex({ pais, ano: selectedYear }).then((data) => {
      setCostosHardwareFlex(data || []);
    });
  };

  // ─── Publicidad / Bloque A (ingresos + comisiones) ──────────
  const {
    valoresMensuales: valoresMensualesPub,
    valoresMensualesAnoAnterior: valoresMensualesPubAA,
    publicidadMensualesCombinados: publicidadCombPub,
    facturasPorMes,
    valoresMensualesComisionAgencia: valoresMensualesComisionAgenciaPub,
    valoresMensualesComisionAgenciaAnoAnterior: valoresMensualesComisionAgenciaPubAA,
    valoresMensualesComisionAgenciaChile: valoresMensualesComisionAgenciaPubChile,
    valoresMensualesComisionAgenciaPeru: valoresMensualesComisionAgenciaPubPeru,
    valoresMensualesComisionBroker: valoresMensualesComisionBrokerPub,
    valoresMensualesComisionBrokerAnoAnterior: valoresMensualesComisionBrokerPubAA,
    valoresMensualesComisionBrokerChile: valoresMensualesComisionBrokerPubChile,
    valoresMensualesComisionBrokerPeru: valoresMensualesComisionBrokerPubPeru,
    comisionesBrokerPorMes,
    comisionesAgenciaPorMes,
    costosProgramaticosPorMes,
    valoresMensualesTake,
    valoresMensualesTakeAnoAnterior,
    valoresMensualesTakeChile,
    valoresMensualesTakePeru,
    apxPorMes,
    valoresMensualesApx: valoresMensualesApxPub,
    valoresMensualesApxAnoAnterior: valoresMensualesApxPubAA,
    valoresMensualesApxChile: valoresMensualesApxPubChile,
    valoresMensualesApxPeru: valoresMensualesApxPubPeru,
    valoresMensualesComisiones: valoresMensualesComisionesPub,
    valoresMensualesComisionesAnoAnterior: valoresMensualesComisionesPubAA,
    valoresMensualesComisionesChile: valoresMensualesComisionesPubChile,
    valoresMensualesComisionesPeru: valoresMensualesComisionesPubPeru,
    comisionesEdificiosPorMes,
    valoresMensualesComisionComercial: valoresMensualesComisionComercialPub,
    valoresMensualesComisionComercialAnoAnterior: valoresMensualesComisionComercialPubAA,
    valoresMensualesComisionComercialChile: valoresMensualesComisionComercialPubChile,
    valoresMensualesComisionComercialPeru: valoresMensualesComisionComercialPubPeru,
    // ytdComisionAgencia y ytdComisionComercial se recalculan abajo combinando PAUTA + contratos
    // ytdComisiones se recalcula abajo combinando PAUTA + contratos
  } = usePublicidadCalcs({
    pais,
    selectedYear,
    monthsToShow,
    currentYear,
    modoCombinado,
    oportunidades,
    oportunidadesChile,
    oportunidadesPeru,
    clientes,
    clientesChile,
    clientesPeru,
    intermediarios,
    intermediariosChile,
    intermediariosPeru,
    edificios,
    edificiosChile,
    edificiosPeru,
    snapMap,
    snapMapChile,
    snapMapPeru,
    costosMap,
    costosMapChile,
    costosMapPeru,
    users,
    isOportunidadesLoading,
    dolarMensualChile,
    dolarMensualPeru,
    dolarFallback,
    getDolarValue,
    getDolarValueChile,
    getDolarValuePeru,
  });

  // Publicidad + Contratos combinados (contratos se suman a publicidad)
  const sumarArrays = useCallback((a, b) => a.map((v, i) => v + (b[i] || 0)), []);
  const valoresMensuales = useMemo(
    () => sumarArrays(valoresMensualesPub, ingresosContratosMensual),
    [sumarArrays, valoresMensualesPub, ingresosContratosMensual]
  );
  const valoresMensualesAnoAnterior = useMemo(
    () => sumarArrays(valoresMensualesPubAA, ingresosContratosMensualAnoAnterior),
    [sumarArrays, valoresMensualesPubAA, ingresosContratosMensualAnoAnterior]
  );
  const publicidadMensualesCombinados = useMemo(() => {
    if (!publicidadCombPub) return contratosMensualesCombinados;
    if (!contratosMensualesCombinados) return publicidadCombPub;
    return sumarArrays(publicidadCombPub, contratosMensualesCombinados);
  }, [sumarArrays, publicidadCombPub, contratosMensualesCombinados]);

  // Comisiones fijas edificios (USD → moneda local con TC del 1ro de cada mes)
  const comisionesFijasMensual = useMemo(
    () => calcularComisionesFijasMensuales(edificios, selectedYear, getDolarValue),
    [edificios, selectedYear, getDolarValue]
  );

  // Detalle fijo por mes para el modal (edificio, monto, montoLocal)
  const comisionesFijasPorMes = useMemo(() => {
    const resultado = Array.from({ length: 12 }, () => []);
    const edificiosList = Object.values(edificios || {});
    for (let mes = 0; mes < 12; mes++) {
      const fechaPrimero = `${selectedYear}-${String(mes + 1).padStart(2, "0")}-01`;
      edificiosList.forEach((ed) => {
        if (!esEdificioComisionFija(ed, fechaPrimero)) return;
        const monto = Number(ed.comision_fija_monto) || 0;
        if (monto <= 0) return;
        const moneda = (ed.comision_fija_moneda || "USD").toUpperCase();
        const tc = getDolarValue(fechaPrimero);
        const montoLocal = moneda === "USD" ? monto * tc : monto;
        resultado[mes].push({
          edificio: ed.edificio || `Edificio ${ed.id}`,
          montoUSD: monto,
          montoLocal,
        });
      });
    }
    return resultado;
  }, [edificios, selectedYear, getDolarValue]);
  const comisionesFijasMensualAA = useMemo(
    () => calcularComisionesFijasMensuales(edificios, selectedYear - 1, getDolarValue),
    [edificios, selectedYear, getDolarValue]
  );
  const comisionesFijasMensualChile = useMemo(
    () => calcularComisionesFijasMensuales(edificiosChile, selectedYear, getDolarValueChile),
    [edificiosChile, selectedYear, getDolarValueChile]
  );
  const comisionesFijasMensualPeru = useMemo(
    () => calcularComisionesFijasMensuales(edificiosPeru, selectedYear, getDolarValuePeru),
    [edificiosPeru, selectedYear, getDolarValuePeru]
  );

  // Comisión edificios: PAUTA + Contratos + Fijas combinados
  const valoresMensualesComisiones = useMemo(
    () =>
      sumarArrays(
        sumarArrays(valoresMensualesComisionesPub, comisionEdificiosContratosMensual),
        comisionesFijasMensual
      ),
    [sumarArrays, valoresMensualesComisionesPub, comisionEdificiosContratosMensual, comisionesFijasMensual]
  );
  const valoresMensualesComisionesAnoAnterior = useMemo(
    () =>
      sumarArrays(
        sumarArrays(valoresMensualesComisionesPubAA, comisionEdificiosContratosMensualAnoAnterior),
        comisionesFijasMensualAA
      ),
    [
      sumarArrays,
      valoresMensualesComisionesPubAA,
      comisionEdificiosContratosMensualAnoAnterior,
      comisionesFijasMensualAA,
    ]
  );
  const valoresMensualesComisionesChile = useMemo(
    () =>
      sumarArrays(
        sumarArrays(valoresMensualesComisionesPubChile, comisionEdificiosContratosMensualChile),
        comisionesFijasMensualChile
      ),
    [
      sumarArrays,
      valoresMensualesComisionesPubChile,
      comisionEdificiosContratosMensualChile,
      comisionesFijasMensualChile,
    ]
  );
  const valoresMensualesComisionesPeru = useMemo(
    () =>
      sumarArrays(
        sumarArrays(valoresMensualesComisionesPubPeru, comisionEdificiosContratosMensualPeru),
        comisionesFijasMensualPeru
      ),
    [sumarArrays, valoresMensualesComisionesPubPeru, comisionEdificiosContratosMensualPeru, comisionesFijasMensualPeru]
  );
  const ytdComisiones = useMemo(
    () => valoresMensualesComisiones.slice(0, monthsToShow).reduce((acc, val) => acc + val, 0),
    [valoresMensualesComisiones, monthsToShow]
  );

  // Comisión agencia: PAUTA + Contratos combinados
  const valoresMensualesComisionAgencia = useMemo(
    () => sumarArrays(valoresMensualesComisionAgenciaPub, comisionAgenciaContratosMensual),
    [sumarArrays, valoresMensualesComisionAgenciaPub, comisionAgenciaContratosMensual]
  );
  const valoresMensualesComisionAgenciaAnoAnterior = useMemo(
    () => sumarArrays(valoresMensualesComisionAgenciaPubAA, comisionAgenciaContratosMensualAnoAnterior),
    [sumarArrays, valoresMensualesComisionAgenciaPubAA, comisionAgenciaContratosMensualAnoAnterior]
  );
  const valoresMensualesComisionAgenciaChile = useMemo(
    () => sumarArrays(valoresMensualesComisionAgenciaPubChile, comisionAgenciaContratosMensualChile),
    [sumarArrays, valoresMensualesComisionAgenciaPubChile, comisionAgenciaContratosMensualChile]
  );
  const valoresMensualesComisionAgenciaPeru = useMemo(
    () => sumarArrays(valoresMensualesComisionAgenciaPubPeru, comisionAgenciaContratosMensualPeru),
    [sumarArrays, valoresMensualesComisionAgenciaPubPeru, comisionAgenciaContratosMensualPeru]
  );
  const ytdComisionAgencia = useMemo(
    () => valoresMensualesComisionAgencia.slice(0, monthsToShow).reduce((acc, val) => acc + val, 0),
    [valoresMensualesComisionAgencia, monthsToShow]
  );

  // ─── COMISIÓN BROKER combinada (PAUTA + contratos) — capa aislada/aditiva ───
  const valoresMensualesComisionBroker = useMemo(
    () => sumarArrays(valoresMensualesComisionBrokerPub, comisionBrokerContratosMensual),
    [sumarArrays, valoresMensualesComisionBrokerPub, comisionBrokerContratosMensual]
  );
  const valoresMensualesComisionBrokerAnoAnterior = useMemo(
    () => sumarArrays(valoresMensualesComisionBrokerPubAA, comisionBrokerContratosMensualAnoAnterior),
    [sumarArrays, valoresMensualesComisionBrokerPubAA, comisionBrokerContratosMensualAnoAnterior]
  );
  const valoresMensualesComisionBrokerChile = useMemo(
    () => sumarArrays(valoresMensualesComisionBrokerPubChile, comisionBrokerContratosMensualChile),
    [sumarArrays, valoresMensualesComisionBrokerPubChile, comisionBrokerContratosMensualChile]
  );
  const valoresMensualesComisionBrokerPeru = useMemo(
    () => sumarArrays(valoresMensualesComisionBrokerPubPeru, comisionBrokerContratosMensualPeru),
    [sumarArrays, valoresMensualesComisionBrokerPubPeru, comisionBrokerContratosMensualPeru]
  );
  const ytdComisionBroker = useMemo(
    () => valoresMensualesComisionBroker.slice(0, monthsToShow).reduce((acc, val) => acc + val, 0),
    [valoresMensualesComisionBroker, monthsToShow]
  );

  // ─── TAKE PROGRAMÁTICO (FASE 6) — capa aislada/aditiva ───
  // `valoresMensualesTake` (total mensual local, solo PAUTA) viene del hook. Es la suma de la
  // línea "Costo intermediación" Y el COSTO que entra al agregado de costos variables del EBITDA.
  const ytdTake = useMemo(
    () => valoresMensualesTake.slice(0, monthsToShow).reduce((acc, val) => acc + val, 0),
    [valoresMensualesTake, monthsToShow]
  );

  // ─── APX (Publicis) combinado: PAUTA + Contratos ───
  // Mismo patrón que las comisiones (`*Pub` → combinado). El APX de contratos (apx_id a nivel
  // contrato) entra a la línea "Costo intermediación" y a los 4 agregados igual que el de pauta.
  const valoresMensualesApx = useMemo(
    () => sumarArrays(valoresMensualesApxPub, comisionApxContratosMensual),
    [sumarArrays, valoresMensualesApxPub, comisionApxContratosMensual]
  );
  const valoresMensualesApxAnoAnterior = useMemo(
    () => sumarArrays(valoresMensualesApxPubAA, comisionApxContratosMensualAnoAnterior),
    [sumarArrays, valoresMensualesApxPubAA, comisionApxContratosMensualAnoAnterior]
  );
  const valoresMensualesApxChile = useMemo(
    () => sumarArrays(valoresMensualesApxPubChile, comisionApxContratosMensualChile),
    [sumarArrays, valoresMensualesApxPubChile, comisionApxContratosMensualChile]
  );
  const valoresMensualesApxPeru = useMemo(
    () => sumarArrays(valoresMensualesApxPubPeru, comisionApxContratosMensualPeru),
    [sumarArrays, valoresMensualesApxPubPeru, comisionApxContratosMensualPeru]
  );

  // ─── APX (Publicis, etapa 2) — capa aislada/aditiva, mismo molde que el take ───
  const ytdApx = useMemo(
    () => valoresMensualesApx.slice(0, monthsToShow).reduce((acc, val) => acc + val, 0),
    [valoresMensualesApx, monthsToShow]
  );

  // Comisión comercial: PAUTA + Contratos combinados
  const valoresMensualesComisionComercial = useMemo(
    () => ({
      valores: sumarArrays(valoresMensualesComisionComercialPub.valores, comisionComercialContratosMensual),
      comisionesPorOportunidad: valoresMensualesComisionComercialPub.comisionesPorOportunidad,
    }),
    [sumarArrays, valoresMensualesComisionComercialPub, comisionComercialContratosMensual]
  );
  const valoresMensualesComisionComercialAnoAnterior = useMemo(
    () => sumarArrays(valoresMensualesComisionComercialPubAA, comisionComercialContratosMensualAnoAnterior),
    [sumarArrays, valoresMensualesComisionComercialPubAA, comisionComercialContratosMensualAnoAnterior]
  );
  const valoresMensualesComisionComercialChile = useMemo(
    () => sumarArrays(valoresMensualesComisionComercialPubChile, comisionComercialContratosMensualChile),
    [sumarArrays, valoresMensualesComisionComercialPubChile, comisionComercialContratosMensualChile]
  );
  const valoresMensualesComisionComercialPeru = useMemo(
    () => sumarArrays(valoresMensualesComisionComercialPubPeru, comisionComercialContratosMensualPeru),
    [sumarArrays, valoresMensualesComisionComercialPubPeru, comisionComercialContratosMensualPeru]
  );
  const ytdComisionComercial = useMemo(
    () => valoresMensualesComisionComercial.valores.slice(0, monthsToShow).reduce((acc, val) => acc + val, 0),
    [valoresMensualesComisionComercial, monthsToShow]
  );

  const valoresMargenContribucion = useMemo(() => {
    const valores = Array(12).fill(0);
    for (let i = 0; i < 12; i++) {
      if (i < monthsToShow) {
        const facturado = valoresMensuales[i] || 0;
        const comisionAgencia = valoresMensualesComisionAgencia[i] || 0;
        const comisionEdificios = valoresMensualesComisiones[i] || 0;
        const comisionComercial = valoresMensualesComisionComercial.valores[i] || 0;
        // FASE 6: el take programático es costo real (las comisiones ya vienen reducidas).
        const take = valoresMensualesTake[i] || 0;
        // APX (Publicis): mismo criterio que el take (costo real, las comisiones ya reducidas).
        const apx = valoresMensualesApx[i] || 0;

        const costoInternet = getValueForMonth("Servicios internet", i + 1).value || 0;
        const costoSoftware = getValueForMonth("Software DS", i + 1).value || 0;
        const costoMantenimiento = getValueForMonth("Mantenimiento", i + 1).value || 0;

        valores[i] =
          facturado -
          comisionAgencia -
          comisionEdificios -
          comisionComercial -
          take -
          apx -
          costoInternet -
          costoSoftware -
          costoMantenimiento;
      }
    }
    return valores;
  }, [
    valoresMensuales,
    valoresMensualesComisionAgencia,
    valoresMensualesComisiones,
    valoresMensualesComisionComercial,
    valoresMensualesTake,
    valoresMensualesApx,
    getValueForMonth, // ← Añadir dependencia
    monthsToShow,
  ]);

  const ytdMargenContribucion = useMemo(
    () =>
      valoresMargenContribucion
        .slice(0, monthsToShow)
        .reduce((acc, val) => acc + (typeof val === "number" ? val : 0), 0),
    [valoresMargenContribucion, monthsToShow]
  );

  // ─── Hardware / Bloque B (ingresos, costos, márgenes) ───────
  const {
    ingresosHardwareMensual,
    ingresosHardwareMensualAnoAnterior,
    ingresosHardwareMensualChile,
    ingresosHardwareMensualPeru,
    compraHardwareMensual,
    instalacionMensual,
    materialesMensual,
    otrosCostosMensual,
    compraHardwareMensualAnoAnterior,
    instalacionMensualAnoAnterior,
    materialesMensualAnoAnterior,
    otrosCostosMensualAnoAnterior,
    compraHardwareMensualChile,
    instalacionMensualChile,
    materialesMensualChile,
    otrosCostosMensualChile,
    compraHardwareMensualPeru,
    instalacionMensualPeru,
    materialesMensualPeru,
    otrosCostosMensualPeru,
    ytdIngresosHardware,
    ytdCompraHardware,
    ytdInstalacion,
    ytdMateriales,
    ytdOtrosCostosHardware,
    ytdMargenHardware,
  } = useHardwareCalcs({
    pais,
    selectedYear,
    monthsToShow,
    negociosCarteleria,
    negociosCarteleriaChile,
    negociosCarteleriaPeru,
    costosHardwareFlex,
    costosHardwareFlexAnoAnterior,
    costosHardwareFlexChile,
    costosHardwareFlexPeru,
    costosGestionData,
    getUFValue,
    getDolarValue,
    getDolarValueChile,
    getDolarValuePeru,
  });

  const formatearConcepto = (texto) => {
    if (!texto || typeof texto !== "string") return "";
    const limpio = texto.trim();
    if (limpio.length === 0) return "";
    return limpio.charAt(0).toUpperCase() + limpio.slice(1);
  };

  const generarIdUnico = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 9);

  const openEditModal = (concept, monthIndex, campo = null) => {
    if (concept === "RRHH") {
      toast.info("RRHH se calcula automáticamente desde Gestión de Empleados");
      return;
    }
    const month = monthIndex + 1;
    if (month > monthsToShow + 1) {
      toast.info("No se pueden editar meses futuros");
      return;
    }

    // === NUEVO: Detectar si es "Varios" y año >= 2026 ===
    if (concept === "Varios" && campo === "varios" && selectedYear >= 2026) {
      const row = rawCostosFijos.find((r) => Number(r.mes) === month && Number(r.ano) === selectedYear);
      const detalleExistente = row?.varios_detalle || [];
      const detalleArray = Array.isArray(detalleExistente) ? detalleExistente : [];

      setVariosDetalleTemp([...detalleArray]);
      setEditingVariosMonthIndex(monthIndex);
      setNuevoVariosConcepto("");
      setNuevoVariosMonto("");
      setIsVariosModalOpen(true);
      return;
    }

    // Caso especial: Asesoría externa
    if (concept === "Asesoría externa" && campo === "asesoria_externa") {
      // Buscar valores actuales en rawCostosFijos (mes exacto)
      const row = rawCostosFijos.find((r) => Number(r.mes) === month);
      const usdActual = row?.asesoria_externa_usd || 0;
      const fechaActual =
        row?.asesoria_externa_fecha || new Date(selectedYear, monthIndex + 1, 0).toISOString().split("T")[0]; // último día mes por default

      setAsesoriaUsd(usdActual);
      setAsesoriaFecha(fechaActual);
      setEditingAsesoriaMonthIndex(monthIndex);

      // Calcular preview inicial
      const dolar = getDolarValue(fechaActual);
      setAsesoriaPreviewLocal(Math.round(usdActual * dolar));

      setIsAsesoriaModalOpen(true);
      return;
    }

    // Resto de conceptos: lógica original (sin cambios)
    let initialValue = 0;
    if (campo) {
      initialValue = costosFijosData[monthIndex]?.[campo] || 0;
    } else if (conceptosManuales.includes(concept)) {
      const { value } = getValueForMonth(concept, month);
      initialValue = value;
    } else if (["Software DS", "Otros"].includes(concept)) {
      const field = concept === "Software DS" ? "software_ds" : "otros";
      const row = costosGestionData.find((c) => parseInt(c.mes) === month);
      initialValue = row ? Number(row[field]) || 0 : 0;
    }
    setEditValue(initialValue);
    setEditingConcept({ concept, month, campo });
    setIsEditModalOpen(true);
  };

  const agregarItemVarios = () => {
    const conceptoFormateado = formatearConcepto(nuevoVariosConcepto);

    if (!conceptoFormateado) {
      toast.error("El concepto es obligatorio");
      return;
    }

    const montoNum = parseFloat(nuevoVariosMonto) || 0;

    const nuevoItem = {
      id: generarIdUnico(),
      concepto: conceptoFormateado,
      monto: montoNum,
    };

    setVariosDetalleTemp([...variosDetalleTemp, nuevoItem]);
    setNuevoVariosConcepto("");
    setNuevoVariosMonto("");
    toast.success(`"${conceptoFormateado}" agregado`);
  };

  const eliminarItemVarios = (itemId, concepto) => {
    if (!window.confirm(`¿Eliminar "${concepto}"?`)) return;
    setVariosDetalleTemp(variosDetalleTemp.filter((item) => item.id !== itemId));
    toast.success("Eliminado");
  };

  const calcularTotalVarios = () => variosDetalleTemp.reduce((sum, item) => sum + (Number(item.monto) || 0), 0);

  const guardarVariosDetalle = async () => {
    const mes = editingVariosMonthIndex + 1;
    const totalVarios = calcularTotalVarios();

    try {
      const updateData = {
        pais,
        ano: selectedYear,
        mes,
        varios: totalVarios,
        varios_detalle: variosDetalleTemp,
      };

      const { error } = await client.from("costos_fijos").upsert(updateData, {
        onConflict: ["pais", "ano", "mes"],
      });

      if (error) throw error;

      const rawData = await getCostosFijos({ pais, ano: selectedYear });
      setRawCostosFijos(rawData || []);

      const normalized = Array(12)
        .fill(null)
        .map((_, i) => {
          const row = rawData?.find((r) => Number(r.mes) === i + 1);
          const mesData = {};
          camposCostosFijos.forEach((c) => {
            mesData[c] = Number(row?.[c]) || 0;
          });
          mesData.asesoria_externa_usd = row?.asesoria_externa_usd || null;
          mesData.asesoria_externa_fecha = row?.asesoria_externa_fecha || null;
          mesData.varios_detalle = row?.varios_detalle || [];
          return mesData;
        });
      setCostosFijosData(normalized);

      toast.success("Varios guardado correctamente");
      cerrarModalVarios();
    } catch (err) {
      console.error("Error guardando varios:", err);
      toast.error("Error al guardar: " + (err.message || "Desconocido"));
    }
  };

  const cerrarModalVarios = () => {
    setIsVariosModalOpen(false);
    setEditingVariosMonthIndex(null);
    setVariosDetalleTemp([]);
    setNuevoVariosConcepto("");
    setNuevoVariosMonto("");
  };

  const openSoftwareDSModalA = (monthIndex) => {
    if (monthIndex >= monthsToShow) {
      toast("Solo meses pasados");
      return;
    }

    if (!puedeEditar) return;

    // Fecha fija: día 1 del mes
    const año = currentYear;
    const mes = monthIndex + 1;
    const fechaDia1 = `${año}-${String(mes).padStart(2, "0")}-01`;

    // Valor actual guardado en costos_publicidad
    const row = costosPublicidadData[monthIndex];
    const valorActual = row ? Number(row.software_ds) || 0 : 0;

    // Dólar del día 1
    const dolarDia1 = getDolarValue(fechaDia1);

    // Convertir valor actual a cantidad de licencias (redondeo)
    const licenciasActuales = valorActual > 0 && dolarDia1 > 0 ? Math.round(valorActual / (10.99 * dolarDia1)) : 0;

    setEditingSoftwareDSMonthIndexA(monthIndex);
    setSoftwareDSLicenciasA(licenciasActuales);
    setSoftwareDSPreviewLocalA(Math.round(licenciasActuales * 10.99 * dolarDia1));

    setIsSoftwareDSModalOpenA(true);
  };

  const openSoftwareDSModalC = (monthIndex) => {
    if (monthIndex >= monthsToShow || !puedeEditar) return;

    const pantallas = detalleGestionContenidosPorMes[monthIndex].reduce((sum, item) => sum + item.pantallas, 0);

    const fechaDia1 = `${currentYear}-${String(monthIndex + 1).padStart(2, "0")}-01`;
    const dolar = getDolarValue(fechaDia1);

    const valorActual = getCostoGestionValue(monthIndex, "software_ds");
    const licenciasActuales = valorActual > 0 ? Math.round(valorActual / (10.99 * dolar)) : pantallas;

    setEditingSoftwareDSMonthIndexC(monthIndex);
    setSoftwareDSLicenciasC(licenciasActuales);
    setSoftwareDSPreviewLocalC(Math.round(licenciasActuales * 10.99 * dolar));
    setIsSoftwareDSModalOpenC(true);
  };

  // === GUARDAR UNIFICADO ===
  const saveCost = async () => {
    if (!editingConcept) return;
    const { concept, month, campo } = editingConcept;

    try {
      // COSTOS FIJOS
      if (campo) {
        await guardarCostoFijo(month - 1, campo, editValue);
      }
      // COSTOS PUBLICIDAD (A)
      else if (conceptosManuales.includes(concept)) {
        const currentRow = costosPublicidadData[month - 1] || {};
        await upsertCostosPublicidad({
          pais,
          ano: selectedYear,
          mes: month,
          servicios_internet:
            concept === "Servicios internet"
              ? editValue === ""
                ? null
                : Number(editValue)
              : (currentRow.servicios_internet ?? null),
          software_ds:
            concept === "Software DS"
              ? editValue === ""
                ? null
                : Number(editValue)
              : (currentRow.software_ds ?? null),
          mantenimiento:
            concept === "Mantenimiento"
              ? editValue === ""
                ? null
                : Number(editValue)
              : (currentRow.mantenimiento ?? null),
        });
        const updated = await getCostosPublicidad({ pais, ano: selectedYear });
        setCostosPublicidadData(updated);
        toast.success("Costo guardado");
      }
      // GESTIÓN Y CONTENIDOS (C)
      else if (["Software DS", "Otros"].includes(concept)) {
        await upsertCostoGestion({
          negocio_id: null,
          pais,
          ano: selectedYear,
          mes: month,
          tipo: concept === "Software DS" ? "software_ds" : "otros",
          value: editValue === "" ? 0 : Number(editValue),
        });
        const mapa = await getCostosGestion({ pais, ano: selectedYear });
        setCostosGestionData(mapa);
        toast.success("Costo guardado");
      }

      closeEditModal();
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error al guardar");
    }
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingConcept(null);
    setEditValue(0);
  };

  const showGestionContenidosModal = async (monthIndex) => {
    if (monthIndex < monthsToShow && detalleGestionContenidosPorMes[monthIndex].length > 0) {
      setSelectedGestionContenidosMonth(monthIndex);

      const { data } = await client
        .from("costos_gestion_contenidos")
        .select("*")
        .eq("pais", pais)
        .eq("ano", selectedYear);

      setCostosGestionData(data || []);
      setModalRefresh((prev) => prev + 1);
      setIsGestionContenidosModalOpen(true);
    }
  };

  const closeGestionContenidosModal = () => {
    setIsGestionContenidosModalOpen(false);
    setSelectedGestionContenidosMonth(null);
  };

  const getNombreNegocio = useCallback(
    (n) => {
      if (n.tipo_vertical === "TD") {
        return clientes[n.referencia_id]?.nombre || `Cliente ${n.referencia_id}`;
      }
      if (n.tipo_vertical === "OT") {
        return clientes[n.referencia_id]?.nombre || edificios[n.referencia_id]?.edificio || `Ref ${n.referencia_id}`;
      }
      return edificios[n.referencia_id]?.edificio || `Edificio ${n.referencia_id}`;
    },
    [clientes, edificios]
  );

  // === TOTALES FINALES ===
  const totalFacturacion = useMemo(
    () =>
      valoresMensuales.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
      ingresosHardwareMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
      ingresosGestionContenidosMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
      ingresosBTLMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
    [valoresMensuales, ingresosHardwareMensual, ingresosGestionContenidosMensual, ingresosBTLMensual, monthsToShow]
  );

  const totalCostos = useMemo(() => {
    const comAg = valoresMensualesComisionAgencia.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    const comEd = valoresMensualesComisiones.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    const comCom = valoresMensualesComisionComercial.valores.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    const manuales = conceptosManuales.reduce((sum, c) => sum + getYTDManual(c), 0);
    const hw = ytdCompraHardware + ytdInstalacion + ytdMateriales + ytdOtrosCostosHardware;
    const ges = ytdSoftwareDS + ytdOtros;
    const btl =
      comisionEdificiosBTLMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
      otrosCostosBTLMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    // FASE 6: take programático YTD (costo real, además de las comisiones ya reducidas).
    const take = valoresMensualesTake.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    // APX (Publicis) YTD: mismo criterio que el take.
    const apx = valoresMensualesApx.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    const total = comAg + comEd + comCom + take + apx + manuales + hw + ges + btl;
    return total;
  }, [
    valoresMensualesComisionAgencia,
    valoresMensualesComisiones,
    valoresMensualesComisionComercial,
    valoresMensualesTake,
    valoresMensualesApx,
    ytdCompraHardware,
    ytdInstalacion,
    ytdMateriales,
    ytdOtrosCostosHardware,
    ytdSoftwareDS,
    ytdOtros,
    monthsToShow,
    getYTDManual,
    conceptosManuales,
    comisionEdificiosBTLMensual,
    otrosCostosBTLMensual,
  ]);

  const openEditGestion = (monthIndex, tipo) => {
    if (monthIndex >= monthsToShow) {
      toast.info("No se pueden editar meses futuros");
      return;
    }
    const mes = monthIndex + 1;
    const valorActual = getCostoGestionValue(monthIndex, tipo);

    setEditingConcept({
      concept: tipo === "software_ds" ? "Software DS" : "Otros",
      month: mes,
      tipo,
    });
    setEditValue(valorActual);
    setIsEditModalOpen(true);
  };

  const guardarCostoFijo = async (mesIndex, campo, valor, usd = null, fecha = null) => {
    const mes = mesIndex + 1;
    try {
      const updateData = {
        pais,
        ano: selectedYear,
        mes,
        [campo]: valor === "" ? null : parseFloat(valor) || 0,
      };

      // Solo si es asesoria_externa y tenemos extras
      if (campo === "asesoria_externa") {
        updateData.asesoria_externa_usd = usd !== null ? (usd === "" ? null : parseFloat(usd)) : null;
        updateData.asesoria_externa_fecha = fecha || null;
      }

      const { error } = await client.from("costos_fijos").upsert(updateData, {
        onConflict: ["pais", "ano", "mes"],
      });
      if (error) throw error;

      // Recarga
      const rawData = await getCostosFijos({ pais, ano: selectedYear });
      setRawCostosFijos(rawData || []);
      const normalized = Array(12)
        .fill(null)
        .map((_, i) => {
          const row = rawData?.find((r) => Number(r.mes) === i + 1);
          const mesData = {};
          camposCostosFijos.forEach((c) => {
            mesData[c] = Number(row?.[c]) || 0;
          });
          // Incluir extras para asesoria
          mesData.asesoria_externa_usd = row?.asesoria_externa_usd || null;
          mesData.asesoria_externa_fecha = row?.asesoria_externa_fecha || null;
          mesData.varios_detalle = row?.varios_detalle || [];
          return mesData;
        });
      setCostosFijosData(normalized);
      toast.success("Guardado correctamente");
    } catch (err) {
      console.error("Error guardando costo fijo:", err);
      toast.error("Error al guardar: " + (err.message || "Desconocido"));
    }
  };

  const totalCostosMes = useCallback(
    (monthIndex) => {
      if (monthIndex >= monthsToShow) return 0;

      // Software DS: usar valor real si existe, si no el estimado (consistente con costosVariablesMensual)
      const softwareSupabase = getCostoGestionValue(monthIndex, "software_ds") || 0;
      const softwareUsado = softwareSupabase > 0 ? softwareSupabase : calcularCostoSoftwareEstimado(monthIndex);

      return (
        // A - Comisiones y costos manuales
        (valoresMensualesComisionAgencia[monthIndex] || 0) +
        (valoresMensualesComisiones[monthIndex] || 0) +
        (valoresMensualesComisionComercial.valores[monthIndex] || 0) +
        // Take programático (FASE 6): costo real, además de las comisiones ya reducidas.
        (valoresMensualesTake[monthIndex] || 0) +
        // APX (Publicis): mismo criterio que el take.
        (valoresMensualesApx[monthIndex] || 0) +
        conceptosManuales.reduce((sum, c) => {
          const { value } = getValueForMonth(c, monthIndex + 1);
          return sum + (value || 0);
        }, 0) +
        // B - Hardware
        (compraHardwareMensual[monthIndex] || 0) +
        (instalacionMensual[monthIndex] || 0) +
        (materialesMensual[monthIndex] || 0) +
        (otrosCostosMensual[monthIndex] || 0) +
        // C - Gestión y Contenidos
        softwareUsado +
        (getCostoGestionValue(monthIndex, "otros") || 0) +
        // D - BTL
        (comisionEdificiosBTLMensual[monthIndex] || 0) +
        (otrosCostosBTLMensual[monthIndex] || 0)
      );
    },
    [
      monthsToShow,
      valoresMensualesComisionAgencia,
      valoresMensualesComisiones,
      valoresMensualesComisionComercial,
      valoresMensualesTake,
      valoresMensualesApx,
      getValueForMonth,
      compraHardwareMensual,
      instalacionMensual,
      materialesMensual,
      otrosCostosMensual,
      getCostoGestionValue,
      calcularCostoSoftwareEstimado,
      conceptosManuales,
      comisionEdificiosBTLMensual,
      otrosCostosBTLMensual,
    ]
  );

  const openBTLModal = (monthIndex) => {
    if (monthIndex >= monthsToShow) return;
    const tieneDatos = ingresosBTLMensual[monthIndex] > 0;
    if (tieneDatos) {
      setSelectedBTLMonth(monthIndex);
      setIsBTLModalOpen(true);
    }
  };

  const guardarOtrosCostosBTL = async (id, valor) => {
    const num = valor === "" ? 0 : parseFloat(valor) || 0;
    if (num < 0) {
      toast.error("No puede ser negativo");
      return;
    }

    try {
      const { error } = await client.from("sales_btl").update({ otros_costos: num }).eq("id", id);

      if (error) throw error;

      toast.success("Guardado");
      // Actualizar el estado correcto según el país de la sesión
      if (pais === "Chile") {
        setSalesBTLChile((prev) => prev.map((r) => (r.id === id ? { ...r, otros_costos: num } : r)));
      } else {
        setSalesBTLPeru((prev) => prev.map((r) => (r.id === id ? { ...r, otros_costos: num } : r)));
      }
      setEditingBTLId(null);
      setTempOtrosCostos("");
    } catch {
      toast.error("Error al guardar");
    }
  };

  // Calculamos el YTD de toda la facturación una sola vez
  const ytdFacturacion = useMemo(
    () =>
      valoresMensuales.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
      ingresosHardwareMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
      ingresosGestionContenidosMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
      ingresosBTLMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
    [valoresMensuales, ingresosHardwareMensual, ingresosGestionContenidosMensual, ingresosBTLMensual, monthsToShow]
  );

  const ytdPublicidad = useMemo(
    () => valoresMensuales.slice(0, monthsToShow).reduce((acc, val) => acc + val, 0),
    [valoresMensuales, monthsToShow]
  );

  const formatPercentage = (value) => {
    if (!value || value === 0) return "0%";
    const locale = showInDollars ? "en-US" : pais === "Chile" ? "es-CL" : "es-PE";
    const dec = Math.abs(value) < 10 ? 1 : 0;
    return value.toLocaleString(locale, { minimumFractionDigits: dec, maximumFractionDigits: dec }) + "%";
  };

  const porcentajeSobreFacturacion = (valor, baseOverride = null) => {
    // En modo combinado usar ytdFacturacionRegionUSD, salvo que se pase una base explícita
    // En modo ventana: usar facturación windowed (eFact se define más abajo pero es accesible vía closure)
    const base =
      baseOverride !== null
        ? baseOverride
        : modoCombinado
          ? ytdFacturacionRegionUSD
          : verUltimos12Meses
            ? eFact.reduce((a, b) => a + b, 0)
            : ytdFacturacion;
    if (!base || base === 0) return "0%";
    const porcentaje = (valor / base) * 100;
    return formatPercentage(porcentaje);
  };

  const margenPorcentaje = (margen, ingresos) => {
    if (!ingresos || ingresos === 0) return "0%";
    const porcentaje = (margen / ingresos) * 100;
    return formatPercentage(porcentaje);
  };

  const recargarHardwareFlex = async () => {
    const fresh = await getCostosHardwareFlex({ pais, ano: selectedYear });
    setCostosHardwareFlex(fresh || []);
  };

  // ← CARGA HISTÓRICA COMPLETA (una sola vez por país)
  useEffect(() => {
    const cargarHistoriaCompleta = async () => {
      if (!pais) return;

      const años = [2023, 2024, 2025, 2026];
      const nuevaHistoria = { ...historiaER };

      for (const año of años) {
        if (nuevaHistoria[año] !== null) continue;

        // === PARCHE CHILE 2024 ===
        if (pais === "Chile" && año === 2024) {
          nuevaHistoria[año] = {
            facturacion: 88_044_577,
            ebitda: -75_083_031,
            margen: -85.3, // ya calculado
          };
          continue;
        }

        try {
          const [opps, costosFijosRaw] = await Promise.all([
            getOportunidades({ pais, ano: año }),
            getCostosFijos({ pais, ano: año }),
          ]);

          let facturacion = 0;
          opps
            .filter((o) => o.facturafecha && !o.eliminada)
            .forEach((o) => {
              const fecha = new Date(o.facturafecha);
              if (fecha.getFullYear() === año) {
                facturacion += Number(o.importe) || 0;
              }
            });

          if (año === selectedYear) {
            facturacion = ytdFacturacion;
          }

          const costosFijosTotal = costosFijosRaw.reduce(
            (sum, r) =>
              sum +
              (Number(r.rrhh) || 0) +
              (Number(r.contador) || 0) +
              (Number(r.oficina) || 0) +
              (Number(r.transporte) || 0) +
              (Number(r.telefonia) || 0) +
              (Number(r.marketing) || 0) +
              (Number(r.gastos_representacion) || 0) +
              (Number(r.alojamiento) || 0) +
              (Number(r.viajes_gerencia) || 0) +
              (Number(r.gastos_bancarios) || 0) +
              (Number(r.varios) || 0),
            0
          );

          const ebitda = facturacion - costosFijosTotal;

          nuevaHistoria[año] = {
            facturacion: Math.round(facturacion),
            ebitda: Math.round(ebitda),
            margen: facturacion > 0 ? Number((ebitda / facturacion) * 100).toFixed(1) : 0,
          };
        } catch (err) {
          console.error(`Error cargando historia ${año}:`, err);
          nuevaHistoria[año] = { facturacion: 0, ebitda: 0, margen: 0 };
        }
      }

      setHistoriaER(nuevaHistoria);
    };

    cargarHistoriaCompleta();
  }, [pais, selectedYear, ytdFacturacion]);

  const openHardwareIngresosModal = (monthIndex) => {
    const negociosDelMes = negociosCarteleria
      .map((n) => {
        if (!n.incluye_hardware || n.eliminada) return null;
        if (!["100%", "Activo"].includes(n.estado)) return null;

        // ── Modo "facturado real": si hay entries OPEX en meses_facturacion ──
        const mesesFact = Array.isArray(n.meses_facturacion) ? n.meses_facturacion : [];
        const opexEntries = mesesFact.filter((e) => e && e.tipo === "opex" && e.facturafecha);
        if (opexEntries.length > 0) {
          const cuotasDelMes = opexEntries.filter((e) => {
            const [fy, fm] = e.facturafecha.split("-").map(Number);
            return fy === selectedYear && fm - 1 === monthIndex;
          });
          if (cuotasDelMes.length === 0) return null;
          return { ...n, _cuotasEnMes: cuotasDelMes.length, _facturaFecha: cuotasDelMes[0].facturafecha };
        }

        if (n.modalidad === "OPEX" && n.cuota_hardware_opex && n.fecha_cierre) {
          const fechaCierre = new Date(n.fecha_cierre);
          const mesCierre = fechaCierre.getMonth();
          const añoCierre = fechaCierre.getFullYear();
          if (añoCierre > selectedYear) return null;
          const totalCuotas = Number(n.num_cuotas) || Number(n.plazo_contrato_meses) || 36;
          const mesesTranscurridos = (selectedYear - añoCierre) * 12 + (monthIndex - mesCierre);
          if (mesesTranscurridos >= 0 && mesesTranscurridos < totalCuotas) {
            return { ...n, _cuotasEnMes: 1, _facturaFecha: null };
          }
          return null;
        }

        if (n.modalidad === "CAPEX") {
          const tienePagoPrincipal = n.detalle_pagos_hardware?.some(
            (p) =>
              p.fecha_factura &&
              new Date(p.fecha_factura).getMonth() === monthIndex &&
              new Date(p.fecha_factura).getFullYear() === selectedYear
          );
          const tienePagoOtros = n.detalle_otros_hardware?.some(
            (p) =>
              p.fecha_factura &&
              new Date(p.fecha_factura).getMonth() === monthIndex &&
              new Date(p.fecha_factura).getFullYear() === selectedYear
          );
          const tieneFechaCierre =
            n.fecha_cierre &&
            new Date(n.fecha_cierre).getMonth() === monthIndex &&
            new Date(n.fecha_cierre).getFullYear() === selectedYear;
          if (tienePagoPrincipal || tienePagoOtros || tieneFechaCierre) {
            // Si el match es solo por fecha_cierre (sin desglose), propagar esa fecha al modal
            const _facturaFecha = !tienePagoPrincipal && !tienePagoOtros && tieneFechaCierre ? n.fecha_cierre : null;
            return { ...n, _cuotasEnMes: 1, _facturaFecha };
          }
          return null;
        }

        return null;
      })
      .filter(Boolean);

    setDetalleHardwareIngresos({ monthIndex, negocios: negociosDelMes });
    setIsHardwareIngresosModalOpen(true);
  };

  // === COSTOS VARIABLES COMBINADOS (ambos países en USD) ===
  // Usa los mismos sub-arrays per-country que los ER locales (comisiones, HW, BTL).
  // Para conceptos manuales y gestión, lee datos crudos per-country con .find() por mes.
  const costosVariablesMensualesCombinados = useMemo(() => {
    if (!modoCombinado) return null;

    // --- Helpers: proyección ventana 12 meses (año actual + año anterior) ---
    const getProjectedPub = (costosArr, costosArrAA, campo, monthIndex) => {
      const valores12Meses = [];
      // Primero: meses del año actual (anteriores al mes proyectado)
      for (let i = 0; i < monthIndex; i++) {
        const row = costosArr[i];
        if (row && row[campo] != null) {
          const val = Number(row[campo]) || 0;
          if (val > 0) valores12Meses.push(val);
        }
      }
      // Segundo: completar con año anterior (desde diciembre hacia atrás)
      if (costosArrAA && costosArrAA.length > 0) {
        for (let i = 11; i >= 0 && valores12Meses.length < 12; i--) {
          const row = costosArrAA[i];
          if (row && row[campo] != null) {
            const val = Number(row[campo]) || 0;
            if (val > 0) valores12Meses.push(val);
          }
        }
      }
      if (valores12Meses.length === 0) return 0;
      return Math.round(valores12Meses.reduce((a, b) => a + b, 0) / valores12Meses.length);
    };

    const getProjectedGes = (cgArr, cgArrAA, campo) => {
      const vals = [];
      // Año actual
      cgArr
        .filter((c) => c && c.negocio_id == null && c[campo] != null)
        .forEach((c) => {
          const v = Number(c[campo]) || 0;
          if (v > 0) vals.push(v);
        });
      // Año anterior (completar hasta 12)
      if (cgArrAA && vals.length < 12) {
        cgArrAA
          .filter((c) => c && c.negocio_id == null && c[campo] != null)
          .forEach((c) => {
            if (vals.length >= 12) return;
            const v = Number(c[campo]) || 0;
            if (v > 0) vals.push(v);
          });
      }
      return vals.length > 0 ? Math.round(vals.reduce((a, b) => a + b, 0) / vals.length) : 0;
    };

    const getPantallas = (negocios, monthIndex) => {
      let p = 0;
      negocios.forEach((n) => {
        if (n.eliminada || n.estado !== "Activo" || !n.fecha_inicio) return;
        const fi = new Date(n.fecha_inicio);
        const plazo = parseInt(n.plazo_contrato_meses) || 0;
        if (plazo === 0) return;
        const ff = new Date(fi);
        ff.setMonth(fi.getMonth() + plazo);
        if (new Date(selectedYear, monthIndex, 15) >= fi && new Date(selectedYear, monthIndex, 15) < ff) {
          p += parseInt(n.cantidad_pantallas) || 1;
        }
      });
      return p;
    };

    const costoCart = (negocios, monthIndex, dolar) => Math.round(getPantallas(negocios, monthIndex) * 10.99 * dolar);

    // --- Función genérica: CV de un país en moneda local ---
    const computeCVPais = (cfg) => {
      const proyGesOtros = getProjectedGes(cfg.cgData, cfg.cgDataAA, "otros");

      return Array(12)
        .fill(0)
        .map((_, i) => {
          // Sub-arrays per-country (mismos que usa el ER local)
          const comisiones =
            (cfg.comAg[i] || 0) + (cfg.comBroker?.[i] || 0) + (cfg.comEd[i] || 0) + (cfg.comCom[i] || 0);
          // FASE 6: el take es costo real → se suma al CV (las comisiones ya vienen reducidas).
          const take = cfg.take?.[i] || 0;
          // APX (Publicis): mismo criterio que el take.
          const apx = cfg.apx?.[i] || 0;
          const hw = (cfg.compraHW[i] || 0) + (cfg.inst[i] || 0) + (cfg.mat[i] || 0) + (cfg.otrosHW[i] || 0);
          const btl = (cfg.comBTL[i] || 0) + (cfg.otrosBTL[i] || 0);

          // Conceptos manuales (publicidad) - proyección ventana 12 meses per-month
          // Software DS: proyectar con valores CRUDOS (igual que getProjectedValue del ER local),
          // restar cartelería solo cuando hay dato real (igual que getSoftwareDSValueA)
          const cp = cfg.cpData[i];
          const proySI = getProjectedPub(cfg.cpData, cfg.cpDataAA, "servicios_internet", i);
          const servInt = cp && cp.servicios_internet != null ? Number(cp.servicios_internet) || 0 : proySI;
          const cartLocal = costoCart(cfg.negCart, i, cfg.dolar[i] || cfg.fb);
          const proySoftDS = getProjectedPub(cfg.cpData, cfg.cpDataAA, "software_ds", i);
          const softDS = cp && cp.software_ds != null ? Math.max(0, Number(cp.software_ds) - cartLocal) : proySoftDS;
          const proyMant = getProjectedPub(cfg.cpData, cfg.cpDataAA, "mantenimiento", i);
          const mant = cp && cp.mantenimiento != null ? Number(cp.mantenimiento) || 0 : proyMant;

          // Gestión - buscar por mes con .find() (consistente con getCostoGestionValue)
          const cgRow = cfg.cgData.find((c) => Number(c.mes) === i + 1 && c.negocio_id == null);
          const gesSDSRaw = Number(cgRow?.software_ds) || 0;
          const gesSDS = gesSDSRaw > 0 ? gesSDSRaw : cartLocal;
          const gesOtros = cgRow ? Number(cgRow.otros) || 0 : proyGesOtros;

          return comisiones + take + apx + hw + btl + servInt + softDS + mant + gesSDS + gesOtros;
        });
    };

    const cvChile = computeCVPais({
      comAg: valoresMensualesComisionAgenciaChile,
      comBroker: valoresMensualesComisionBrokerChile,
      comEd: valoresMensualesComisionesChile,
      comCom: valoresMensualesComisionComercialChile,
      take: valoresMensualesTakeChile,
      apx: valoresMensualesApxChile,
      compraHW: compraHardwareMensualChile,
      inst: instalacionMensualChile,
      mat: materialesMensualChile,
      otrosHW: otrosCostosMensualChile,
      comBTL: comisionEdificiosBTLMensualChile,
      otrosBTL: otrosCostosBTLMensualChile,
      cpData: costosPublicidadChile,
      cpDataAA: costosPublicidadChileAA,
      cgData: costosGestionChile,
      cgDataAA: costosGestionChileAA,
      negCart: negociosCarteleriaChile,
      dolar: dolarMensualChile,
      fb: dolarFallback.Chile,
    });

    const cvPeru = computeCVPais({
      comAg: valoresMensualesComisionAgenciaPeru,
      comBroker: valoresMensualesComisionBrokerPeru,
      comEd: valoresMensualesComisionesPeru,
      comCom: valoresMensualesComisionComercialPeru,
      take: valoresMensualesTakePeru,
      apx: valoresMensualesApxPeru,
      compraHW: compraHardwareMensualPeru,
      inst: instalacionMensualPeru,
      mat: materialesMensualPeru,
      otrosHW: otrosCostosMensualPeru,
      comBTL: comisionEdificiosBTLMensualPeru,
      otrosBTL: otrosCostosBTLMensualPeru,
      cpData: costosPublicidadPeru,
      cpDataAA: costosPublicidadPeruAA,
      cgData: costosGestionPeru,
      cgDataAA: costosGestionPeruAA,
      negCart: negociosCarteleriaPeru,
      dolar: dolarMensualPeru,
      fb: dolarFallback["Perú"],
    });

    // Combinar: convertir cada país a USD y sumar
    return Array(12)
      .fill(0)
      .map(
        (_, i) =>
          cvChile[i] / (dolarMensualChile[i] || dolarFallback.Chile) +
          cvPeru[i] / (dolarMensualPeru[i] || dolarFallback["Perú"])
      );
  }, [
    modoCombinado,
    valoresMensualesComisionAgenciaChile,
    valoresMensualesComisionAgenciaPeru,
    valoresMensualesComisionBrokerChile,
    valoresMensualesComisionBrokerPeru,
    valoresMensualesComisionesChile,
    valoresMensualesComisionesPeru,
    valoresMensualesComisionComercialChile,
    valoresMensualesComisionComercialPeru,
    valoresMensualesTakeChile,
    valoresMensualesTakePeru,
    valoresMensualesApxChile,
    valoresMensualesApxPeru,
    compraHardwareMensualChile,
    instalacionMensualChile,
    materialesMensualChile,
    otrosCostosMensualChile,
    compraHardwareMensualPeru,
    instalacionMensualPeru,
    materialesMensualPeru,
    otrosCostosMensualPeru,
    costosPublicidadChile,
    costosPublicidadPeru,
    costosPublicidadChileAA,
    costosPublicidadPeruAA,
    costosGestionChile,
    costosGestionPeru,
    costosGestionChileAA,
    costosGestionPeruAA,
    comisionEdificiosBTLMensualChile,
    comisionEdificiosBTLMensualPeru,
    otrosCostosBTLMensualChile,
    otrosCostosBTLMensualPeru,
    dolarMensualChile,
    dolarMensualPeru,
    dolarFallback,
    negociosCarteleriaChile,
    negociosCarteleriaPeru,
    selectedYear,
  ]);

  const margenFinal = totalFacturacion - totalCostos;

  // eslint-disable-next-line no-unused-vars
  const ebitdaYTDAcumulado = margenFinal - costosFijosYTD; // este es el EBITDA real acumulado hasta hoy

  // Inversión mensual combinada Chile+Perú en USD
  const inversionMensualesCombinados = useMemo(() => {
    if (!modoCombinado) return null;
    const resultado = Array(12).fill(0);
    for (let i = 0; i < 12; i++) {
      const chileUSD = (inversionMensualChile[i] || 0) / (dolarMensualChile[i] || dolarFallback.Chile);
      const peruUSD = (inversionMensualPeru[i] || 0) / (dolarMensualPeru[i] || dolarFallback["Perú"]);
      resultado[i] = chileUSD + peruUSD;
    }
    return resultado;
  }, [modoCombinado, inversionMensualChile, inversionMensualPeru, dolarMensualChile, dolarMensualPeru, dolarFallback]);

  // Valor en libros combinado Chile+Perú en USD
  const valorActivosCombinados = useMemo(() => {
    if (!modoCombinado) return null;
    const resultado = Array(12).fill(0);
    for (let i = 0; i < 12; i++) {
      const chileUSD = (valorActivosMensualChile[i] || 0) / (dolarMensualChile[i] || dolarFallback.Chile);
      const peruUSD = (valorActivosMensualPeru[i] || 0) / (dolarMensualPeru[i] || dolarFallback["Perú"]);
      resultado[i] = chileUSD + peruUSD;
    }
    return resultado;
  }, [
    modoCombinado,
    valorActivosMensualChile,
    valorActivosMensualPeru,
    dolarMensualChile,
    dolarMensualPeru,
    dolarFallback,
  ]);

  const {
    facturacionMensual,
    facturacionMensualAnoAnterior: facturacionMensualAA,
    costosVariablesMensual,
    costosVariablesMensualAnoAnterior: costosVariablesMensualAA,
    ebitdaMensual,
    ebitdaMensualAnoAnterior: ebitdaMensualAA,
    hardwareMensualesCombinados,
    btlMensualesCombinados,
    depreciacionMensualesCombinados,
    amortizacionMensualesCombinados,
    runRateAnual,
    facturacionUltimos12Meses,
    runRateParaMostrar,
    ebitdaRunRateParaMostrar,
    variacionFactParaMostrar,
    variacionEbitdaParaMostrar,
  } = useEBITDACalcs({
    valoresMensuales,
    valoresMensualesAnoAnterior,
    ingresosHardwareMensual,
    ingresosHardwareMensualAnoAnterior,
    ingresosHardwareMensualChile,
    ingresosHardwareMensualPeru,
    ingresosGestionContenidosMensual,
    ingresosGestionContenidosMensualAnoAnterior,
    ingresosBTLMensual,
    ingresosBTLMensualAnoAnterior,
    ingresosBTLMensualChile,
    ingresosBTLMensualPeru,
    valoresMensualesComisionAgencia,
    valoresMensualesComisionAgenciaAnoAnterior,
    valoresMensualesComisionBroker,
    valoresMensualesComisionBrokerAnoAnterior,
    valoresMensualesComisiones,
    valoresMensualesComisionesAnoAnterior,
    valoresMensualesComisionComercial,
    valoresMensualesComisionComercialAnoAnterior,
    valoresMensualesTake,
    valoresMensualesTakeAnoAnterior,
    valoresMensualesApx,
    valoresMensualesApxAnoAnterior,
    compraHardwareMensual,
    instalacionMensual,
    materialesMensual,
    otrosCostosMensual,
    compraHardwareMensualAnoAnterior,
    instalacionMensualAnoAnterior,
    materialesMensualAnoAnterior,
    otrosCostosMensualAnoAnterior,
    comisionEdificiosBTLMensual,
    otrosCostosBTLMensual,
    comisionEdificiosBTLMensualAnoAnterior,
    otrosCostosBTLMensualAnoAnterior,
    getCostoGestionValue,
    getCostoGestionValueAnoAnterior,
    calcularCostoSoftwareEstimado,
    getValueForMonth,
    conceptosManuales,
    costosPublicidadDataAnoAnterior,
    sumarCostosFijosMes,
    costosFijosMensualAnoAnterior,
    costosFijosMensualesCombinados,
    publicidadMensualesCombinados,
    gestionMensualesCombinados,
    costosVariablesMensualesCombinados,
    depreciacionMensualChile,
    depreciacionMensualPeru,
    amortizacionMensualChile,
    amortizacionMensualPeru,
    dolarMensual,
    dolarMensualAnoAnterior,
    dolarMensualChile,
    dolarMensualPeru,
    monthsToShow,
    selectedYear,
    currentYear,
    modoCombinado,
    pais,
    verEnDolares,
    dolarFallback,
  });

  // ─── Unit Economics ──────────────────────────────────────────────────────────
  const { pantallasOperativasMensual, datosCompletos: unitEconomicsReady } = useUnitEconomics({
    edificios,
    negociosCarteleria,
    selectedYear,
  });

  const formatCurrency = (val, monthIndex, ...args) => {
    if (verUnitEconomics && monthIndex != null) {
      const p = pantallasOperativasMensual[monthIndex] || 0;
      return formatCurrencyBase(p > 0 ? Math.round(val / p) : 0, monthIndex, ...args);
    }
    return formatCurrencyBase(val, monthIndex, ...args);
  };

  // ─── Benchmark inversión en activos (10% facturación, base trimestral) ──────
  // Single country: se computan abajo desde eFact/eInversion (soporta LTM windowed)

  const benchmarkInversionCombinados = useMemo(() => {
    if (!modoCombinado || selectedYear < 2026) return null;
    return Array(12)
      .fill(0)
      .map((_, i) => {
        const factMes =
          (publicidadMensualesCombinados?.[i] || 0) +
          (hardwareMensualesCombinados?.[i] || 0) +
          (gestionMensualesCombinados?.[i] || 0) +
          (btlMensualesCombinados?.[i] || 0);
        return factMes * 0.1;
      });
  }, [
    modoCombinado,
    selectedYear,
    publicidadMensualesCombinados,
    hardwareMensualesCombinados,
    gestionMensualesCombinados,
    btlMensualesCombinados,
  ]);

  const disponibleInversionCombinados = useMemo(() => {
    if (!modoCombinado || selectedYear < 2026) return null;
    let acumBench = 0;
    let acumInv = 0;
    return Array(12)
      .fill(0)
      .map((_, i) => {
        const factMes =
          (publicidadMensualesCombinados?.[i] || 0) +
          (hardwareMensualesCombinados?.[i] || 0) +
          (gestionMensualesCombinados?.[i] || 0) +
          (btlMensualesCombinados?.[i] || 0);
        acumBench += factMes * 0.1;
        acumInv += inversionMensualesCombinados?.[i] || 0;
        return acumBench - acumInv;
      });
  }, [
    modoCombinado,
    selectedYear,
    publicidadMensualesCombinados,
    hardwareMensualesCombinados,
    gestionMensualesCombinados,
    btlMensualesCombinados,
    inversionMensualesCombinados,
  ]);

  // ─── Ventana 12 meses rodante ──────────────────────────────
  const effectiveMonthsToShow = verUltimos12Meses ? 12 : monthsToShow;

  const mesesWindowed = useMemo(() => {
    if (!verUltimos12Meses) return meses;
    return Array.from({ length: 12 }, (_, j) => {
      const realMonth = (monthsToShow + j) % 12;
      const year = j < 12 - monthsToShow ? selectedYear - 1 : selectedYear;
      return `${meses[realMonth]} ${String(year).slice(2)}`;
    });
  }, [verUltimos12Meses, monthsToShow, selectedYear]);

  // Arrays windowed: combinan año anterior + actual en ventana de 12 meses
  const w12 = useMemo(() => {
    if (!verUltimos12Meses) return null;
    const w = (curr, prev) => windowArray(curr, prev, monthsToShow);

    const wValMen = w(valoresMensuales, valoresMensualesAnoAnterior);
    const wIngHW = w(ingresosHardwareMensual, ingresosHardwareMensualAnoAnterior);
    const wIngGC = w(ingresosGestionContenidosMensual, ingresosGestionContenidosMensualAnoAnterior);
    const wIngBTL = w(ingresosBTLMensual, ingresosBTLMensualAnoAnterior);
    const wComAg = w(valoresMensualesComisionAgencia, valoresMensualesComisionAgenciaAnoAnterior);
    const wComEd = w(valoresMensualesComisiones, valoresMensualesComisionesAnoAnterior);
    const wCompHW = w(compraHardwareMensual, compraHardwareMensualAnoAnterior);
    const wInstHW = w(instalacionMensual, instalacionMensualAnoAnterior);
    const wMatHW = w(materialesMensual, materialesMensualAnoAnterior);
    const wOtrosHW = w(otrosCostosMensual, otrosCostosMensualAnoAnterior);
    const wComBTL = w(comisionEdificiosBTLMensual, comisionEdificiosBTLMensualAnoAnterior);
    const wOtrosBTL = w(otrosCostosBTLMensual, otrosCostosBTLMensualAnoAnterior);
    const wRRHH = w(rrhhMensualConBeneficios, rrhhMensualConBeneficiosAnoAnterior);
    const wDolar = w(dolarMensual, dolarMensualAnoAnterior);
    const wDeprec = w(depreciacionMensual, depreciacionMensualAnoAnterior);
    const wAmort = w(amortizacionMensual, amortizacionMensualAnoAnterior);
    const wInversion = w(inversionMensual, inversionMensualAnoAnterior);
    const wValorActivos = w(valorActivosMensual, valorActivosMensualAnoAnterior);
    const wCF = w(
      Array.from({ length: 12 }, (_, i) => sumarCostosFijosMes(i)),
      costosFijosMensualAnoAnterior
    );

    const wFact = w(facturacionMensual, facturacionMensualAA);
    const wCV = w(costosVariablesMensual, costosVariablesMensualAA);
    const wEBITDA = w(ebitdaMensual, ebitdaMensualAA);

    return {
      valoresMensuales: wValMen,
      ingresosHardwareMensual: wIngHW,
      ingresosGestionContenidosMensual: wIngGC,
      ingresosBTLMensual: wIngBTL,
      valoresMensualesComisionAgencia: wComAg,
      valoresMensualesComisiones: wComEd,
      compraHardwareMensual: wCompHW,
      instalacionMensual: wInstHW,
      materialesMensual: wMatHW,
      otrosCostosMensual: wOtrosHW,
      comisionEdificiosBTLMensual: wComBTL,
      otrosCostosBTLMensual: wOtrosBTL,
      rrhhMensualConBeneficios: wRRHH,
      dolarMensual: wDolar,
      depreciacionMensual: wDeprec,
      amortizacionMensual: wAmort,
      inversionMensual: wInversion,
      valorActivosMensual: wValorActivos,
      costosFijosMensual: wCF,
      facturacionMensual: wFact,
      costosVariablesMensual: wCV,
      ebitdaMensual: wEBITDA,
    };
  }, [
    verUltimos12Meses,
    monthsToShow,
    valoresMensuales,
    valoresMensualesAnoAnterior,
    ingresosHardwareMensual,
    ingresosHardwareMensualAnoAnterior,
    ingresosGestionContenidosMensual,
    ingresosGestionContenidosMensualAnoAnterior,
    ingresosBTLMensual,
    ingresosBTLMensualAnoAnterior,
    valoresMensualesComisionAgencia,
    valoresMensualesComisionAgenciaAnoAnterior,
    valoresMensualesComisiones,
    valoresMensualesComisionesAnoAnterior,
    compraHardwareMensual,
    compraHardwareMensualAnoAnterior,
    instalacionMensual,
    instalacionMensualAnoAnterior,
    materialesMensual,
    materialesMensualAnoAnterior,
    otrosCostosMensual,
    otrosCostosMensualAnoAnterior,
    comisionEdificiosBTLMensual,
    comisionEdificiosBTLMensualAnoAnterior,
    otrosCostosBTLMensual,
    otrosCostosBTLMensualAnoAnterior,
    rrhhMensualConBeneficios,
    rrhhMensualConBeneficiosAnoAnterior,
    dolarMensual,
    dolarMensualAnoAnterior,
    depreciacionMensual,
    depreciacionMensualAnoAnterior,
    inversionMensual,
    inversionMensualAnoAnterior,
    valorActivosMensual,
    valorActivosMensualAnoAnterior,
    sumarCostosFijosMes,
    costosFijosMensualAnoAnterior,
    facturacionMensual,
    facturacionMensualAA,
    costosVariablesMensual,
    costosVariablesMensualAA,
    ebitdaMensual,
    ebitdaMensualAA,
  ]);

  // Año anterior al seleccionado para vs AA
  const añoComparacionAA = selectedYear - 1;

  // Facturación completa año anterior (Publicidad + Hardware + Gestión + BTL)
  // Usa los useMemos dedicados para calcular correctamente
  const facturacionAñoAnteriorCompleta = useMemo(() => {
    // Para Chile 2024, usar dato hardcodeado (no tenemos useMemos para 2024)
    if (pais === "Chile" && añoComparacionAA === 2024) {
      return 88_044_577;
    }
    // Sumar los 12 meses de cada componente
    const pubAA = valoresMensualesAnoAnterior.reduce((a, b) => a + b, 0);
    const hwAA = ingresosHardwareMensualAnoAnterior.reduce((a, b) => a + b, 0);
    const gestAA = ingresosGestionContenidosMensualAnoAnterior.reduce((a, b) => a + b, 0);
    const btlAA = ingresosBTLMensualAnoAnterior.reduce((a, b) => a + b, 0);
    return pubAA + hwAA + gestAA + btlAA;
  }, [
    pais,
    añoComparacionAA,
    valoresMensualesAnoAnterior,
    ingresosHardwareMensualAnoAnterior,
    ingresosGestionContenidosMensualAnoAnterior,
    ingresosBTLMensualAnoAnterior,
  ]);

  // Variación YTD actual vs facturación completa del año anterior al seleccionado
  const varYTDvsFull =
    facturacionAñoAnteriorCompleta > 0
      ? Number(((ytdFacturacion / facturacionAñoAnteriorCompleta - 1) * 100).toFixed(1))
      : null;

  // YTD del año anterior al seleccionado (para vs YTD)
  // Usa los useMemos dedicados para año anterior: Publicidad + Hardware + Gestión + BTL
  const ytdAñoAnterior = useMemo(() => {
    // Si monthsToShow es 12, usamos el año completo (igual que facturacionAñoAnteriorCompleta)
    if (monthsToShow === 12) {
      return facturacionAñoAnteriorCompleta;
    }
    // Para Chile 2024 con meses parciales, usar el dato conocido del YTD
    if (pais === "Chile" && añoComparacionAA === 2024 && monthsToShow < 12) {
      return Math.round((81_147_448 / 12) * monthsToShow);
    }
    // Usar useMemos dedicados para año anterior
    const ytdPublicidadAA = valoresMensualesAnoAnterior.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    const ytdHardwareAA = ingresosHardwareMensualAnoAnterior.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    const ytdGestionAA = ingresosGestionContenidosMensualAnoAnterior.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    const ytdBTLAA = ingresosBTLMensualAnoAnterior.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
    return ytdPublicidadAA + ytdHardwareAA + ytdGestionAA + ytdBTLAA;
  }, [
    monthsToShow,
    añoComparacionAA,
    pais,
    facturacionAñoAnteriorCompleta,
    valoresMensualesAnoAnterior,
    ingresosHardwareMensualAnoAnterior,
    ingresosGestionContenidosMensualAnoAnterior,
    ingresosBTLMensualAnoAnterior,
  ]);

  // Variación YTD vs YTD anterior
  const varYTDvsYTD = ytdAñoAnterior > 0 ? Number(((ytdFacturacion / ytdAñoAnterior - 1) * 100).toFixed(1)) : null;

  // === VARIACIONES YOY PARA MODO REGIÓN ===
  // YTD año anterior Chile en USD (usando dólar promedio real del año anterior desde el service)
  const ytdAñoAnteriorChileUSD = useMemo(() => {
    const dolarPromedio = calcularDolarPromedioAno("Chile", añoComparacionAA) || 1;
    // En enero (monthsToShow=12), usar año completo igual que AA
    if (monthsToShow === 12 && añoComparacionAA === 2024) {
      return 133_800_000 / dolarPromedio;
    }
    if (añoComparacionAA === 2024 && monthsToShow < 12) {
      // Proporcional del año completo
      return Math.round((133_800_000 / 12) * monthsToShow) / dolarPromedio;
    }
    const total = oportunidadesChile
      .filter((o) => o.facturafecha && !o.eliminada && new Date(o.facturafecha).getFullYear() === añoComparacionAA)
      .filter((o) => new Date(o.facturafecha).getMonth() < monthsToShow)
      .reduce((sum, o) => sum + Number(o.importe || 0), 0);
    return total / dolarPromedio;
  }, [oportunidadesChile, monthsToShow, añoComparacionAA]);

  // YTD año anterior Perú en USD (usando dólar promedio real del año anterior desde el service)
  const ytdAñoAnteriorPeruUSD = useMemo(() => {
    const dolarPromedio = calcularDolarPromedioAno("Perú", añoComparacionAA) || 1;
    // En enero (monthsToShow=12), usar año completo igual que AA
    if (monthsToShow === 12 && añoComparacionAA === 2024) {
      // Usar el total del año completo de Perú
      const totalAnual = oportunidadesPeru
        .filter((o) => o.facturafecha && !o.eliminada && new Date(o.facturafecha).getFullYear() === 2024)
        .reduce((sum, o) => sum + Number(o.importe || 0), 0);
      return totalAnual / dolarPromedio;
    }
    const total = oportunidadesPeru
      .filter((o) => o.facturafecha && !o.eliminada && new Date(o.facturafecha).getFullYear() === añoComparacionAA)
      .filter((o) => new Date(o.facturafecha).getMonth() < monthsToShow)
      .reduce((sum, o) => sum + Number(o.importe || 0), 0);
    return total / dolarPromedio;
  }, [oportunidadesPeru, monthsToShow, añoComparacionAA]);

  // YTD año anterior región combinado en USD
  const ytdAñoAnteriorRegionUSD = ytdAñoAnteriorChileUSD + ytdAñoAnteriorPeruUSD;

  // YTD facturación región actual en USD
  const ytdFacturacionRegionUSD = useMemo(() => {
    if (!publicidadMensualesCombinados || !hardwareMensualesCombinados) return 0;
    return (
      (publicidadMensualesCombinados?.slice(0, monthsToShow).reduce((a, b) => a + b, 0) || 0) +
      (hardwareMensualesCombinados?.slice(0, monthsToShow).reduce((a, b) => a + b, 0) || 0) +
      (gestionMensualesCombinados?.slice(0, monthsToShow).reduce((a, b) => a + b, 0) || 0) +
      (btlMensualesCombinados?.slice(0, monthsToShow).reduce((a, b) => a + b, 0) || 0)
    );
  }, [
    publicidadMensualesCombinados,
    hardwareMensualesCombinados,
    gestionMensualesCombinados,
    btlMensualesCombinados,
    monthsToShow,
  ]);

  // Variación YTD región vs YTD año anterior región
  const varYTDvsYTDRegion = useMemo(() => {
    if (!modoCombinado || ytdAñoAnteriorRegionUSD <= 0) return null;
    return Number(((ytdFacturacionRegionUSD / ytdAñoAnteriorRegionUSD - 1) * 100).toFixed(1));
  }, [modoCombinado, ytdFacturacionRegionUSD, ytdAñoAnteriorRegionUSD]);

  // Facturación completa año anterior región en USD (para vs AA)
  const facturacionFullAñoAnteriorChileUSD = useMemo(() => {
    const dolarPromedio = calcularDolarPromedioAno("Chile", añoComparacionAA) || 1;
    if (añoComparacionAA === 2024) {
      return 133_800_000 / dolarPromedio;
    }
    return (historiaER[añoComparacionAA]?.facturacion || 0) / dolarPromedio;
  }, [añoComparacionAA, historiaER]);

  const facturacionFullAñoAnteriorPeruUSD = useMemo(() => {
    const dolarPromedio = calcularDolarPromedioAno("Perú", añoComparacionAA) || 1;
    const total = oportunidadesPeru
      .filter((o) => o.facturafecha && !o.eliminada && new Date(o.facturafecha).getFullYear() === añoComparacionAA)
      .reduce((sum, o) => sum + Number(o.importe || 0), 0);
    return total / dolarPromedio;
  }, [oportunidadesPeru, añoComparacionAA]);

  const facturacionFullAñoAnteriorRegionUSD = facturacionFullAñoAnteriorChileUSD + facturacionFullAñoAnteriorPeruUSD;

  // Variación YTD región vs AA (año anterior completo)
  const varYTDvsFullRegion = useMemo(() => {
    if (!modoCombinado || facturacionFullAñoAnteriorRegionUSD <= 0) return null;
    return Number(((ytdFacturacionRegionUSD / facturacionFullAñoAnteriorRegionUSD - 1) * 100).toFixed(1));
  }, [modoCombinado, ytdFacturacionRegionUSD, facturacionFullAñoAnteriorRegionUSD]);

  // === ALMACENAR COSTOS EN LOCALSTORAGE POR PAÍS/AÑO/CONCEPTO/MES ===
  useEffect(() => {
    if (!pais || !selectedYear) return;

    const costosActuales = {
      bloqueA: {
        comisionAgencias: valoresMensualesComisionAgencia,
        comisionEdificios: valoresMensualesComisiones,
        comisionComercial: valoresMensualesComisionComercial.valores,
        serviciosInternet: Array(12)
          .fill(0)
          .map((_, i) => getValueForMonth("Servicios internet", i + 1).value),
        softwareDS: Array(12)
          .fill(0)
          .map((_, i) => getValueForMonth("Software DS", i + 1).value),
        mantenimiento: Array(12)
          .fill(0)
          .map((_, i) => getValueForMonth("Mantenimiento", i + 1).value),
      },
      bloqueB: {
        compraHardware: compraHardwareMensual,
        instalacion: instalacionMensual,
        materiales: materialesMensual,
        otrosCostos: otrosCostosMensual,
      },
      bloqueC: {
        softwareDS: Array(12)
          .fill(0)
          .map((_, i) => getCostoGestionValue(i, "software_ds")),
        otros: Array(12)
          .fill(0)
          .map((_, i) => getCostoGestionValue(i, "otros")),
      },
      bloqueD: {
        comisionEdificiosBTL: comisionEdificiosBTLMensual,
        otrosCostosBTL: otrosCostosBTLMensual,
      },
      costosFijos: {
        rrhh: rrhhMensualConBeneficios,
        ...camposCostosFijos.reduce((acc, campo) => {
          acc[campo] = Array(12)
            .fill(0)
            .map((_, i) => getCostoFijoValor(campo, i));
          return acc;
        }, {}),
      },
      facturacion: valoresMensuales,
    };

    // Leer storage existente y actualizar solo este país/año
    const storageKey = "erCostosCalculados";
    const existente = JSON.parse(localStorage.getItem(storageKey) || "{}");
    if (!existente[pais]) existente[pais] = {};
    existente[pais][selectedYear] = costosActuales;
    localStorage.setItem(storageKey, JSON.stringify(existente));
  }, [
    pais,
    selectedYear,
    valoresMensualesComisionAgencia,
    valoresMensualesComisiones,
    valoresMensualesComisionComercial,
    compraHardwareMensual,
    instalacionMensual,
    materialesMensual,
    otrosCostosMensual,
    comisionEdificiosBTLMensual,
    otrosCostosBTLMensual,
    rrhhMensualConBeneficios,
    valoresMensuales,
    getValueForMonth,
    getCostoGestionValue,
    getCostoFijoValor,
  ]);

  // ─── Aliases para modo ventana 12 meses ──────────────────
  const eMs = effectiveMonthsToShow;
  const eValMen = w12?.valoresMensuales ?? valoresMensuales;
  const eIngHW = w12?.ingresosHardwareMensual ?? ingresosHardwareMensual;
  const eIngGC = w12?.ingresosGestionContenidosMensual ?? ingresosGestionContenidosMensual;
  const eIngBTL = w12?.ingresosBTLMensual ?? ingresosBTLMensual;
  const eComAg = w12?.valoresMensualesComisionAgencia ?? valoresMensualesComisionAgencia;
  const eComEd = w12?.valoresMensualesComisiones ?? valoresMensualesComisiones;
  const eCompHW = w12?.compraHardwareMensual ?? compraHardwareMensual;
  const eInstHW = w12?.instalacionMensual ?? instalacionMensual;
  const eMatHW = w12?.materialesMensual ?? materialesMensual;
  const eOtrosHW = w12?.otrosCostosMensual ?? otrosCostosMensual;
  const eComBTL = w12?.comisionEdificiosBTLMensual ?? comisionEdificiosBTLMensual;
  const eOtrosBTL = w12?.otrosCostosBTLMensual ?? otrosCostosBTLMensual;
  const eRRHH = w12?.rrhhMensualConBeneficios ?? rrhhMensualConBeneficios;
  const eDolar = w12?.dolarMensual ?? dolarMensual;
  const eDeprec = w12?.depreciacionMensual ?? depreciacionMensual;
  const eAmort = w12?.amortizacionMensual ?? amortizacionMensual;
  const eInversion = w12?.inversionMensual ?? inversionMensual;
  const eValorActivos = w12?.valorActivosMensual ?? valorActivosMensual;
  const eFact = w12?.facturacionMensual ?? facturacionMensual;
  // En LTM, los primeros (12 - monthsToShow) índices son del año anterior → null (no aplica)
  const ltmOffset = verUltimos12Meses ? 12 - monthsToShow : 0;
  const eBenchmarkInv = selectedYear < 2026 ? null : eFact.map((v, i) => (i < ltmOffset ? null : (v || 0) * 0.1));
  const eDisponibleInv =
    selectedYear < 2026
      ? null
      : (() => {
          let acumBench = 0;
          let acumInv = 0;
          return Array.from({ length: 12 }, (_, i) => {
            // Meses del año anterior en LTM → null (no aplica)
            if (i < ltmOffset) return null;
            acumBench += (eFact[i] || 0) * 0.1;
            acumInv += eInversion[i] || 0;
            return acumBench - acumInv;
          });
        })();
  const eCV = w12?.costosVariablesMensual ?? costosVariablesMensual;
  const eCF = w12?.costosFijosMensual ?? null;
  const eEBITDA = w12?.ebitdaMensual ?? ebitdaMensual;

  // ─── Acumulados: EBITDA, EBIT, Resultado Neto ──────────────────
  const acumulados = useMemo(() => {
    const intUSD = interesesMensualesUSD[pais] || 0;
    const impUSD = impuestosMensualesUSD[pais] || 0;
    const rateArr = pais === "Chile" ? eDolar : dolarMensualPeru;
    const fb = pais === "Chile" ? dolarFallback.Chile : dolarFallback["Perú"];

    let ebitdaAcum = 0;
    let ebitAcum = 0;
    let resultadoAcum = 0;
    const ebitdaAcumArr = [];
    const ebitAcumArr = [];
    const resultadoAcumArr = [];

    for (let i = 0; i < 12; i++) {
      const eb = eEBITDA[i] || 0;
      const dep = eDeprec[i] || 0;
      const amort = eAmort[i] || 0;
      const ebit = eb - dep - amort;
      const rate = rateArr[i] || fb;
      const resultado = ebit - intUSD * rate - impUSD * rate;

      if (i < eMs) {
        ebitdaAcum += eb;
        ebitAcum += ebit;
        resultadoAcum += resultado;
      }
      ebitdaAcumArr.push(i < eMs ? ebitdaAcum : null);
      ebitAcumArr.push(i < eMs ? ebitAcum : null);
      resultadoAcumArr.push(i < eMs ? resultadoAcum : null);
    }
    return { ebitdaAcum: ebitdaAcumArr, ebitAcum: ebitAcumArr, resultadoAcum: resultadoAcumArr };
  }, [
    eEBITDA,
    eDeprec,
    eAmort,
    interesesMensualesUSD,
    impuestosMensualesUSD,
    pais,
    eDolar,
    dolarMensualPeru,
    dolarFallback,
    eMs,
  ]);

  // Banner: ventas cerradas (100%) del mes anterior sin facturar
  const ventasCerradasSinVincular = useMemo(() => {
    if (!siiVinculacionesMap) return null;

    const contratos = pais === "Chile" ? contratosChile : contratosPeru;

    const tieneVinculacionSII = (refKey, facturanumero) => {
      if (siiVinculacionesMap._byRef[refKey]) return true;
      if (facturanumero && siiVinculacionesMap[String(facturanumero)]) return true;
      return false;
    };

    const hoy = new Date();
    const mesActualIdx = hoy.getMonth();
    const mesAnteriorIdx = mesActualIdx === 0 ? 11 : mesActualIdx - 1;
    // En enero el "mes anterior" es diciembre del año previo; el resto del año es selectedYear
    const añoMesFactura = mesActualIdx === 0 ? selectedYear - 1 : selectedYear;

    // Pauta (sales): una fila ↔ una factura, mes en mes_factura
    const pendientesPauta = oportunidades.filter((opp) => {
      if (opp.eliminada) return false;
      if (opp.estatus !== "100%") return false;
      // Chile: vinculación por SII. Perú: vinculada si tiene facturanumero o facturafecha
      if (pais === "Chile") {
        if (tieneVinculacionSII(`sales:${opp.id}:`, opp.facturanumero)) return false;
      } else {
        if (opp.facturanumero || opp.facturafecha) return false;
      }
      if (opp.ano !== selectedYear) return false;
      if (!opp.mes_factura) return false;
      // mes_factura formato "M-YYYY" o "MM-YYYY" (ej: "4-2026", "04-2026")
      const partes = String(opp.mes_factura).split("-");
      if (partes.length !== 2) return false;
      const mesOpp = parseInt(partes[0], 10);
      const añoOpp = parseInt(partes[1], 10);
      if (isNaN(mesOpp) || isNaN(añoOpp)) return false;
      return mesOpp - 1 === mesAnteriorIdx && añoOpp === añoMesFactura;
    });

    // Contratos (sales_contratos): explotar JSONB meses → una fila por cuota
    const pendientesContratos = [];
    (contratos || []).forEach((c) => {
      if (c.eliminada) return;
      if (c.estatus !== "100%") return;
      (c.meses || []).forEach((mesObj, idx) => {
        if (!mesObj?.mes) return;
        const partes = String(mesObj.mes).split("-");
        if (partes.length !== 2) return;
        const mesOpp = parseInt(partes[0], 10);
        const añoOpp = parseInt(partes[1], 10);
        if (isNaN(mesOpp) || isNaN(añoOpp)) return;
        if (mesOpp - 1 !== mesAnteriorIdx || añoOpp !== añoMesFactura) return;
        if (pais === "Chile") {
          if (tieneVinculacionSII(`sales_contratos:${c.id}:${idx}`, mesObj.facturanumero)) return;
        } else {
          if (mesObj.facturanumero || mesObj.facturafecha) return;
        }
        pendientesContratos.push({
          id: `contrato-${c.id}-${idx}`,
          importe: Number(mesObj.importe) || 0,
          moneda_dolar: c.moneda_dolar || false,
          facturafecha: mesObj.facturafecha || null,
          fecha_cierre: c.fecha_cierre || null,
          mes_cierre: c.mes_cierre || null,
        });
      });
    });

    const filtradas = [...pendientesPauta, ...pendientesContratos];
    if (filtradas.length === 0) return null;

    const total = filtradas.reduce(
      (sum, opp) => sum + getConvertedImporte(opp, getRateForOpp(opp, getDolarValue, dolarFallback[pais])),
      0
    );

    return { count: filtradas.length, total, mesIdx: mesAnteriorIdx };
  }, [
    oportunidades,
    contratosChile,
    contratosPeru,
    selectedYear,
    pais,
    getDolarValue,
    dolarFallback,
    siiVinculacionesMap,
  ]);

  return (
    <div className={styles.ERWrapper}>
      <ERHeader
        logo={logo}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        verEnDolares={verEnDolares}
        setVerEnDolares={setVerEnDolares}
        verChileYPeru={verChileYPeru}
        setVerChileYPeru={setVerChileYPeru}
        modoCombinado={modoCombinado}
        pais={pais}
        moneda={moneda}
        isOportunidadesLoading={isOportunidadesLoading}
        varYTDvsYTD={varYTDvsYTD}
        varYTDvsYTDRegion={varYTDvsYTDRegion}
        runRateParaMostrar={runRateParaMostrar}
        runRateAnual={runRateAnual}
        facturacionUltimos12Meses={facturacionUltimos12Meses}
        variacionFactParaMostrar={variacionFactParaMostrar}
        varYTDvsFull={varYTDvsFull}
        varYTDvsFullRegion={varYTDvsFullRegion}
        ebitdaRunRateParaMostrar={ebitdaRunRateParaMostrar}
        variacionEbitdaParaMostrar={variacionEbitdaParaMostrar}
        es2026Habilitado={es2026Habilitado}
        verUltimos12Meses={verUltimos12Meses}
        setVerUltimos12Meses={setVerUltimos12Meses}
        monthsToShow={monthsToShow}
        onOpenChart={() => setIsChartModalOpen(true)}
        verAcumulados={verAcumulados}
        setVerAcumulados={setVerAcumulados}
        verUnitEconomics={verUnitEconomics}
        setVerUnitEconomics={setVerUnitEconomics}
        unitEconomicsReady={unitEconomicsReady}
        verInversionActivos={verInversionActivos}
        setVerInversionActivos={setVerInversionActivos}
      />
      <div className={styles.ER}>
        {meses && !isOportunidadesLoading && !isClientesLoading && (
          <table className={styles.tableER}>
            <thead>
              {/* Fila de meses */}
              <tr>
                <th className={styles.conceptCell}>Concepto</th>
                {mesesWindowed.map((mes, index) => (
                  <th key={index} className={styles.valueCell}>
                    {mes}
                  </th>
                ))}
                <th className={styles.totalCellHead}>{verUltimos12Meses ? "LTM" : "YTD"}</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.facturacionRow}>
                <td className={styles.conceptCell}>FACTURACIÓN</td>
                {Array.from({ length: 12 }, (_, i) => {
                  if (i >= eMs)
                    return (
                      <td key={i} className="text-end">
                        -
                      </td>
                    );
                  if (modoCombinado) {
                    const total =
                      (publicidadMensualesCombinados[i] || 0) +
                      (hardwareMensualesCombinados[i] || 0) +
                      (gestionMensualesCombinados[i] || 0) +
                      (btlMensualesCombinados[i] || 0);
                    return (
                      <td key={i} className="text-end">
                        {formatCurrency(total, i, null, true)}
                      </td>
                    );
                  }
                  const total = (eValMen[i] || 0) + (eIngHW[i] || 0) + (eIngGC[i] || 0) + (eIngBTL[i] || 0);
                  return (
                    <td key={i} className="text-end">
                      {formatCurrency(total, i)}
                    </td>
                  );
                })}
                <td className={styles.totalCellYTD}>
                  {modoCombinado
                    ? (() => {
                        let total = 0;
                        for (let i = 0; i < eMs; i++) {
                          total +=
                            (publicidadMensualesCombinados[i] || 0) +
                            (hardwareMensualesCombinados[i] || 0) +
                            (gestionMensualesCombinados[i] || 0) +
                            (btlMensualesCombinados[i] || 0);
                        }
                        return formatCurrency(total, null, null, true);
                      })()
                    : formatCurrency(
                        verUltimos12Meses ? eFact.reduce((a, b) => a + b, 0) : ytdFacturacion,
                        null,
                        eValMen.map((v, i) => v + (eIngHW[i] || 0) + (eIngGC[i] || 0) + (eIngBTL[i] || 0))
                      )}
                </td>
              </tr>
              {/* === BLOQUE A - Publicidad === */}
              <tr
                className={styles.sectionHeader}
                onClick={() => !modoCombinado && !verUltimos12Meses && setBloqueACollapsed(!bloqueACollapsed)}
                style={{
                  cursor: modoCombinado || verUltimos12Meses ? "default" : "pointer",
                  userSelect: "none",
                }}
              >
                <td className={styles.conceptCell}>
                  A - Publicidad {!modoCombinado && !verUltimos12Meses && bloqueACollapsed ? ">" : ""}
                </td>
                {(modoCombinado ? publicidadMensualesCombinados : eValMen).map((valor, index) => (
                  <td key={index}>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          !modoCombinado &&
                          !verUltimos12Meses &&
                          index < monthsToShow &&
                          facturasPorMes[index]?.length > 0
                        ) {
                          showInvoiceModal(index);
                        }
                      }}
                      style={{
                        cursor:
                          !modoCombinado &&
                          !verUltimos12Meses &&
                          index < monthsToShow &&
                          facturasPorMes[index]?.length > 0
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {index < eMs ? formatCurrency(valor, index, null, modoCombinado) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>
                  {modoCombinado
                    ? formatCurrency(
                        publicidadMensualesCombinados.slice(0, eMs).reduce((a, b) => a + b, 0),
                        null,
                        null,
                        true
                      )
                    : formatCurrency(
                        verUltimos12Meses ? eValMen.reduce((a, b) => a + b, 0) : ytdPublicidad,
                        null,
                        eValMen
                      )}{" "}
                  |{" "}
                  {modoCombinado
                    ? porcentajeSobreFacturacion(publicidadMensualesCombinados.slice(0, eMs).reduce((a, b) => a + b, 0))
                    : (() => {
                        const ytdF = verUltimos12Meses ? eFact.reduce((a, b) => a + b, 0) : ytdFacturacion;
                        const ytdP = verUltimos12Meses ? eValMen.reduce((a, b) => a + b, 0) : ytdPublicidad;
                        return ytdF > 0 ? formatPercentage((ytdP / ytdF) * 100) : "0%";
                      })()}
                </td>
              </tr>

              {!modoCombinado && !verUltimos12Meses && !bloqueACollapsed && (
                <>
                  {/* Costo intermediación = agencia + broker + take programático (FASE 6) + APX (Publicis) */}
                  <tr>
                    <td className={styles.conceptCell}>Costo intermediación</td>
                    {valoresMensualesComisionAgencia.map((valorAgencia, index) => {
                      const valorCombinado =
                        (valorAgencia || 0) +
                        (valoresMensualesComisionBroker[index] || 0) +
                        (valoresMensualesTake[index] || 0) +
                        (valoresMensualesApx[index] || 0);
                      const tieneDetalle =
                        index < monthsToShow &&
                        (comisionesAgenciaPorMes[index].length > 0 ||
                          comisionesBrokerPorMes[index].length > 0 ||
                          (costosProgramaticosPorMes[index] || []).length > 0 ||
                          (apxPorMes[index] || []).length > 0);
                      return (
                        <td key={index} className={styles.valueCell}>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              if (tieneDetalle) {
                                setSelectedAgencyMonth(index);
                                setIsAgencyModalOpen(true);
                              }
                            }}
                            style={{ cursor: tieneDetalle ? "pointer" : "default" }}
                          >
                            {index < monthsToShow ? formatCurrency(valorCombinado, index) : "-"}
                          </div>
                        </td>
                      );
                    })}
                    <td className={styles.totalCell}>
                      {formatCurrency(
                        ytdComisionAgencia + ytdComisionBroker + ytdTake + ytdApx,
                        null,
                        valoresMensualesComisionAgencia
                      )}{" "}
                      |{" "}
                      {ytdPublicidad > 0
                        ? formatPercentage(
                            ((ytdComisionAgencia + ytdComisionBroker + ytdTake + ytdApx) / ytdPublicidad) * 100
                          )
                        : "0%"}
                    </td>
                  </tr>

                  {/* Comisiones edificios */}
                  <tr>
                    <td className={styles.conceptCell}>Comisión edificios</td>
                    {valoresMensualesComisiones.map((valor, index) => (
                      <td key={index}>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            if (index < monthsToShow && comisionesEdificiosPorMes[index].length > 0) {
                              showBuildingCommissionModal(index);
                            }
                          }}
                          style={{
                            cursor:
                              index < monthsToShow && comisionesEdificiosPorMes[index].length > 0
                                ? "pointer"
                                : "default",
                          }}
                        >
                          {index < monthsToShow ? formatCurrency(valor, index) : "-"}
                        </div>
                      </td>
                    ))}
                    <td className={styles.totalCell}>
                      {formatCurrency(ytdComisiones, null, valoresMensualesComisiones)} |{" "}
                      {ytdPublicidad > 0 ? formatPercentage((ytdComisiones / ytdPublicidad) * 100) : "0%"}
                    </td>
                  </tr>

                  {/* Comisión comercial */}
                  <tr>
                    <td className={styles.conceptCell}>Comisión comercial</td>
                    {valoresMensualesComisionComercial.valores.map((valor, index) => (
                      <td key={index}>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            if (
                              index < monthsToShow &&
                              oportunidades.some((opp) => {
                                const fecha = new Date(opp.facturafecha);
                                return !isNaN(fecha.getTime()) && fecha.getMonth() === index && opp.ejecutivo;
                              })
                            ) {
                              setSelectedCommercialMonth(index);
                              setIsCommercialModalOpen(true);
                            }
                          }}
                          style={{
                            cursor:
                              index < monthsToShow &&
                              oportunidades.some((opp) => {
                                const fecha = new Date(opp.facturafecha);
                                return !isNaN(fecha.getTime()) && fecha.getMonth() === index && opp.ejecutivo;
                              })
                                ? "pointer"
                                : "default",
                          }}
                        >
                          {index < monthsToShow ? formatCurrency(valor, index) : "-"}
                        </div>
                      </td>
                    ))}
                    <td className={styles.totalCell}>
                      {formatCurrency(ytdComisionComercial, null, valoresMensualesComisionComercial.valores)} |{" "}
                      {ytdPublicidad > 0 ? formatPercentage((ytdComisionComercial / ytdPublicidad) * 100) : "0%"}
                    </td>
                  </tr>

                  {/* Costos manuales */}
                  {conceptosManuales.map((concept) => {
                    const ytdManual = getYTDManual(concept);
                    const hasProjectedInYTD = meses
                      .slice(0, monthsToShow)
                      .some((_, i) => getValueForMonth(concept, i + 1).isProjected);

                    const esSoftwareDS = concept === "Software DS";

                    return (
                      <tr key={concept}>
                        <td className={styles.conceptCell}>{concept}</td>
                        {meses.map((_, index) => {
                          const month = index + 1;
                          const { value, isProjected } = getValueForMonth(concept, month);
                          const isFuture = month > monthsToShow;

                          // Caso especial: Software DS en modo USD → usar dólar día 1
                          if (esSoftwareDS && verEnDolares && !isFuture) {
                            const fechaDia1 = `${selectedYear}-${String(month).padStart(2, "0")}-01`;
                            const dolarDia1 = getDolarValue(fechaDia1);
                            const valorUSD = dolarDia1 > 0 ? Math.round(value / dolarDia1) : 0;
                            const locale = localString(pais);
                            const formatted = valorUSD.toLocaleString(locale, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            });
                            return (
                              <td key={index}>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (puedeEditar) openSoftwareDSModalA(index);
                                  }}
                                  style={{
                                    cursor: puedeEditar ? "pointer" : "default",
                                    backgroundColor: isProjected ? "#fff9c4" : "transparent",
                                  }}
                                  title={isProjected ? "Valor proyectado" : ""}
                                >
                                  US$ {formatted}
                                </div>
                              </td>
                            );
                          }

                          return (
                            <td key={index}>
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!isFuture && puedeEditar) {
                                    if (concept === "Software DS") {
                                      openSoftwareDSModalA(index);
                                    } else {
                                      openEditModal(concept, index);
                                    }
                                  }
                                }}
                                style={{
                                  cursor: !isFuture && puedeEditar ? "pointer" : "default",
                                  backgroundColor: isProjected && !isFuture ? "#fff9c4" : "transparent",
                                }}
                                title={isProjected && !isFuture ? "Valor proyectado" : ""}
                              >
                                {month <= monthsToShow ? formatCurrency(value, index) : "-"}
                              </div>
                            </td>
                          );
                        })}
                        <td
                          className={styles.totalCell}
                          style={{ backgroundColor: hasProjectedInYTD ? "#fff9c4" : "transparent" }}
                        >
                          {/* Caso especial YTD: Software DS en modo USD */}
                          {esSoftwareDS && verEnDolares
                            ? (() => {
                                let totalUsd = 0;
                                for (let i = 0; i < monthsToShow; i++) {
                                  const { value } = getValueForMonth(concept, i + 1);
                                  const fechaDia1 = `${selectedYear}-${String(i + 1).padStart(2, "0")}-01`;
                                  const dolarDia1 = getDolarValue(fechaDia1);
                                  if (value > 0 && dolarDia1 > 0) {
                                    totalUsd += value / dolarDia1;
                                  }
                                }
                                const locale = localString(pais);
                                const formatted = Math.round(totalUsd).toLocaleString(locale, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                });
                                return `US$ ${formatted} | ${ytdPublicidad > 0 ? formatPercentage((ytdManual / ytdPublicidad) * 100) : "0%"}`;
                              })()
                            : `${formatCurrency(
                                ytdManual,
                                null,
                                meses.map((_, i) => getValueForMonth(concept, i + 1).value)
                              )} | ${ytdPublicidad > 0 ? formatPercentage((ytdManual / ytdPublicidad) * 100) : "0%"}`}
                        </td>
                      </tr>
                    );
                  })}

                  {/* Margen Contribución A */}
                  <tr className={styles.marginRow}>
                    <td className={styles.conceptCellMargen}>Contribución</td>
                    {valoresMargenContribucion.map((valor, index) => (
                      <td key={index}>
                        <div className={valor < 0 ? styles.marginNegative : ""}>
                          {index < monthsToShow ? formatCurrency(valor, index) : "-"}
                        </div>
                      </td>
                    ))}
                    <td className={styles.totalCell}>
                      <div className={ytdMargenContribucion < 0 ? styles.marginNegative : ""}>
                        {formatCurrency(ytdMargenContribucion, null, valoresMargenContribucion)} |{" "}
                        {margenPorcentaje(ytdMargenContribucion, ytdPublicidad)}
                      </div>
                    </td>
                  </tr>
                </>
              )}
              <BloqueBTable
                modoCombinado={modoCombinado}
                verUltimos12Meses={verUltimos12Meses}
                bloqueBCollapsed={verUltimos12Meses || bloqueBCollapsed}
                setBloqueBCollapsed={verUltimos12Meses ? () => {} : setBloqueBCollapsed}
                hardwareMensualesCombinados={hardwareMensualesCombinados}
                ingresosHardwareMensual={eIngHW}
                monthsToShow={eMs}
                openHardwareIngresosModal={verUltimos12Meses ? () => {} : openHardwareIngresosModal}
                formatCurrency={formatCurrency}
                formatPercentage={formatPercentage}
                porcentajeSobreFacturacion={porcentajeSobreFacturacion}
                ytdIngresosHardware={verUltimos12Meses ? eIngHW.reduce((a, b) => a + b, 0) : ytdIngresosHardware}
                compraHardwareMensual={eCompHW}
                instalacionMensual={eInstHW}
                materialesMensual={eMatHW}
                otrosCostosMensual={eOtrosHW}
                openHardwareFlexModal={verUltimos12Meses ? () => {} : openHardwareFlexModal}
                ytdCompraHardware={verUltimos12Meses ? eCompHW.reduce((a, b) => a + b, 0) : ytdCompraHardware}
                ytdInstalacion={verUltimos12Meses ? eInstHW.reduce((a, b) => a + b, 0) : ytdInstalacion}
                ytdMateriales={verUltimos12Meses ? eMatHW.reduce((a, b) => a + b, 0) : ytdMateriales}
                ytdOtrosCostosHardware={
                  verUltimos12Meses ? eOtrosHW.reduce((a, b) => a + b, 0) : ytdOtrosCostosHardware
                }
                ytdMargenHardware={
                  verUltimos12Meses
                    ? eIngHW.reduce((a, b) => a + b, 0) -
                      eCompHW.reduce((a, b) => a + b, 0) -
                      eInstHW.reduce((a, b) => a + b, 0) -
                      eMatHW.reduce((a, b) => a + b, 0) -
                      eOtrosHW.reduce((a, b) => a + b, 0)
                    : ytdMargenHardware
                }
                margenPorcentaje={margenPorcentaje}
                verUltimos12Meses={verUltimos12Meses}
              />
              <BloqueCTable
                modoCombinado={modoCombinado}
                verUltimos12Meses={verUltimos12Meses}
                bloqueCCollapsed={verUltimos12Meses || bloqueCCollapsed}
                setBloqueCCollapsed={verUltimos12Meses ? () => {} : setBloqueCCollapsed}
                gestionMensualesCombinados={gestionMensualesCombinados}
                ingresosGestionContenidosMensual={eIngGC}
                detalleGestionContenidosPorMes={detalleGestionContenidosPorMes}
                showGestionContenidosModal={verUltimos12Meses ? () => {} : showGestionContenidosModal}
                formatCurrency={formatCurrency}
                formatPercentage={formatPercentage}
                porcentajeSobreFacturacion={porcentajeSobreFacturacion}
                ytdIngresosGestionContenidos={
                  verUltimos12Meses ? eIngGC.reduce((a, b) => a + b, 0) : ytdIngresosGestionContenidos
                }
                getCostoGestionValue={getCostoGestionValue}
                calcularCostoSoftwareEstimado={calcularCostoSoftwareEstimado}
                verEnDolares={verEnDolares}
                selectedYear={selectedYear}
                getDolarValue={getDolarValue}
                localString={localString}
                pais={pais}
                puedeEditar={verUltimos12Meses ? false : puedeEditar}
                openSoftwareDSModalC={openSoftwareDSModalC}
                openEditGestion={openEditGestion}
                ytdSoftwareDS={ytdSoftwareDS}
                ytdOtros={ytdOtros}
                margenGestionContenidosMensual={margenGestionContenidosMensual}
                ytdMargenGestionContenidos={ytdMargenGestionContenidos}
                margenPorcentaje={margenPorcentaje}
                monthsToShow={eMs}
                verUltimos12Meses={verUltimos12Meses}
              />

              <BloqueDTable
                modoCombinado={modoCombinado}
                verUltimos12Meses={verUltimos12Meses}
                bloqueDCollapsed={verUltimos12Meses || bloqueDCollapsed}
                setBloqueDCollapsed={verUltimos12Meses ? () => {} : setBloqueDCollapsed}
                btlMensualesCombinados={btlMensualesCombinados}
                ingresosBTLMensual={eIngBTL}
                monthsToShow={eMs}
                openBTLModal={verUltimos12Meses ? () => {} : openBTLModal}
                formatCurrency={formatCurrency}
                formatPercentage={formatPercentage}
                ytdIngresosBTL={verUltimos12Meses ? eIngBTL.reduce((a, b) => a + b, 0) : ytdIngresosBTL}
                comisionEdificiosBTLMensual={eComBTL}
                ytdComisionEdificiosBTL={
                  verUltimos12Meses ? eComBTL.reduce((a, b) => a + b, 0) : ytdComisionEdificiosBTL
                }
                otrosCostosBTLMensual={eOtrosBTL}
                ytdOtrosCostosBTL={verUltimos12Meses ? eOtrosBTL.reduce((a, b) => a + b, 0) : ytdOtrosCostosBTL}
                margenBTLMensual={
                  verUltimos12Meses
                    ? eIngBTL.map((v, i) => v - (eComBTL[i] || 0) - (eOtrosBTL[i] || 0))
                    : margenBTLMensual
                }
                ytdMargenBTL={
                  verUltimos12Meses
                    ? eIngBTL.reduce((a, b) => a + b, 0) -
                      eComBTL.reduce((a, b) => a + b, 0) -
                      eOtrosBTL.reduce((a, b) => a + b, 0)
                    : ytdMargenBTL
                }
                porcentajeSobreFacturacion={porcentajeSobreFacturacion}
                margenPorcentaje={margenPorcentaje}
                verUltimos12Meses={verUltimos12Meses}
              />

              {/* === TOTALES FINALES === */}
              <tr className={styles.totalCostosRow}>
                <td className={styles.conceptCell}>Costos Variables</td>
                {(modoCombinado ? costosVariablesMensualesCombinados : eCV).map((val, i) => (
                  <td key={i} className="text-end">
                    {i < eMs ? formatCurrency(val, i, null, modoCombinado) : "-"}
                  </td>
                ))}
                <td className={styles.totalCell}>
                  {formatCurrency(
                    (modoCombinado ? costosVariablesMensualesCombinados : eCV).slice(0, eMs).reduce((a, b) => a + b, 0),
                    null,
                    modoCombinado ? null : eCV,
                    modoCombinado
                  )}{" "}
                  |{" "}
                  {porcentajeSobreFacturacion(
                    (modoCombinado ? costosVariablesMensualesCombinados : eCV).slice(0, eMs).reduce((a, b) => a + b, 0)
                  )}
                </td>
              </tr>

              <tr className={styles.margenFinalRow}>
                <td className={styles.conceptCellMargen}>Beneficio Bruto</td>
                {Array.from({ length: 12 }, (_, i) => {
                  if (i >= eMs) return 0;
                  if (modoCombinado) {
                    const facturado =
                      (publicidadMensualesCombinados[i] || 0) +
                      (hardwareMensualesCombinados[i] || 0) +
                      (gestionMensualesCombinados[i] || 0) +
                      (btlMensualesCombinados[i] || 0);
                    return facturado - (costosVariablesMensualesCombinados[i] || 0);
                  }
                  return (eFact[i] || 0) - (eCV[i] || 0);
                }).map((val, i) => (
                  <td key={i} className="text-end">
                    <div className={val < 0 ? styles.marginNegative : ""}>
                      {i < eMs ? formatCurrency(val, i, null, modoCombinado) : "-"}
                    </div>
                  </td>
                ))}
                <td className={styles.totalCell}>
                  {(() => {
                    if (modoCombinado) {
                      const totalFacturadoCombinado =
                        publicidadMensualesCombinados.slice(0, eMs).reduce((a, b) => a + b, 0) +
                        hardwareMensualesCombinados.slice(0, eMs).reduce((a, b) => a + b, 0) +
                        gestionMensualesCombinados.slice(0, eMs).reduce((a, b) => a + b, 0) +
                        btlMensualesCombinados.slice(0, eMs).reduce((a, b) => a + b, 0);
                      const totalCostosCombinado = costosVariablesMensualesCombinados
                        .slice(0, eMs)
                        .reduce((a, b) => a + b, 0);
                      const margenCombinado = totalFacturadoCombinado - totalCostosCombinado;
                      const pctMargen =
                        totalFacturadoCombinado > 0
                          ? ((margenCombinado / totalFacturadoCombinado) * 100).toFixed(1) + "%"
                          : "0%";
                      return (
                        <div className={margenCombinado < 0 ? styles.marginNegative : ""}>
                          {formatCurrency(margenCombinado, null, null, true)} | {pctMargen}
                        </div>
                      );
                    }
                    const mf = verUltimos12Meses
                      ? eFact.reduce((a, b) => a + b, 0) - eCV.reduce((a, b) => a + b, 0)
                      : margenFinal;
                    return (
                      <div className={mf < 0 ? styles.marginNegative : ""}>
                        {formatCurrency(
                          mf,
                          null,
                          eFact.map((f, i) => f - (eCV[i] || 0))
                        )}{" "}
                        | {porcentajeSobreFacturacion(mf)}
                      </div>
                    );
                  })()}
                </td>
              </tr>
              <CostosFijosTable
                modoCombinado={modoCombinado}
                costosFijosCollapsed={verUltimos12Meses || costosFijosCollapsed}
                setCostosFijosCollapsed={verUltimos12Meses ? () => {} : setCostosFijosCollapsed}
                costosFijosMensualesCombinados={costosFijosMensualesCombinados}
                monthsToShow={eMs}
                sumarCostosFijosMes={sumarCostosFijosMes}
                formatCurrency={formatCurrency}
                porcentajeSobreFacturacion={porcentajeSobreFacturacion}
                costosFijosYTD={verUltimos12Meses ? eCF.reduce((a, b) => a + b, 0) : costosFijosYTD}
                rrhhCollapsed={rrhhCollapsed}
                setRrhhCollapsed={setRrhhCollapsed}
                isEmpleadosRRHHLoading={isEmpleadosRRHHLoading}
                rrhhMensualConBeneficios={eRRHH}
                empleadosRRHH={empleadosRRHH}
                getSueldoBaseVigente={getSueldoBaseVigente}
                selectedYear={selectedYear}
                pais={pais}
                puedeEditar={verUltimos12Meses ? false : puedeEditar}
                nombresCostosFijos={nombresCostosFijos}
                camposCostosFijos={camposCostosFijos}
                meses={mesesWindowed}
                rawCostosFijos={rawCostosFijos}
                costosFijosData={costosFijosData}
                getProjectedCostoFijo={getProjectedCostoFijo}
                verEnDolares={verEnDolares}
                getDolarValue={getDolarValue}
                dolarMensual={eDolar}
                localString={localString}
                openEditModal={openEditModal}
                verUltimos12Meses={verUltimos12Meses}
                costosFijosMensualWindowed={eCF}
              />

              <EBITDAResultadoTable
                modoCombinado={modoCombinado}
                monthsToShow={eMs}
                formatCurrency={formatCurrency}
                porcentajeSobreFacturacion={porcentajeSobreFacturacion}
                publicidadMensualesCombinados={publicidadMensualesCombinados}
                hardwareMensualesCombinados={hardwareMensualesCombinados}
                gestionMensualesCombinados={gestionMensualesCombinados}
                btlMensualesCombinados={btlMensualesCombinados}
                costosVariablesMensualesCombinados={costosVariablesMensualesCombinados}
                costosFijosMensualesCombinados={costosFijosMensualesCombinados}
                valoresMensuales={eValMen}
                ingresosHardwareMensual={eIngHW}
                ingresosGestionContenidosMensual={eIngGC}
                ingresosBTLMensual={eIngBTL}
                camposCostosFijos={camposCostosFijos}
                getCostoFijoValor={getCostoFijoValor}
                rrhhMensualConBeneficios={eRRHH}
                totalCostosMes={totalCostosMes}
                margenFinal={margenFinal}
                costosFijosYTD={verUltimos12Meses ? eCF.reduce((a, b) => a + b, 0) : costosFijosYTD}
                sumarCostosFijosMes={sumarCostosFijosMes}
                valoresMensualesComisionAgencia={eComAg}
                valoresMensualesComisiones={eComEd}
                valoresMensualesComisionComercial={valoresMensualesComisionComercial}
                conceptosManuales={conceptosManuales}
                getValueForMonth={getValueForMonth}
                compraHardwareMensual={eCompHW}
                instalacionMensual={eInstHW}
                materialesMensual={eMatHW}
                otrosCostosMensual={eOtrosHW}
                getCostoGestionValue={getCostoGestionValue}
                comisionEdificiosBTLMensual={eComBTL}
                otrosCostosBTLMensual={eOtrosBTL}
                ebitCollapsed={ebitCollapsed}
                setEbitCollapsed={setEbitCollapsed}
                depreciacionMensualesCombinados={depreciacionMensualesCombinados}
                depreciacionMensual={eDeprec}
                amortizacionMensualesCombinados={amortizacionMensualesCombinados}
                amortizacionMensual={eAmort}
                meses={mesesWindowed}
                resultadoCollapsed={resultadoCollapsed}
                setResultadoCollapsed={setResultadoCollapsed}
                interesesMensualesUSD={interesesMensualesUSD}
                impuestosMensualesUSD={impuestosMensualesUSD}
                verChileYPeru={verChileYPeru}
                verEnDolares={verEnDolares}
                pais={pais}
                moneda={moneda}
                dolarMensual={eDolar}
                dolarMensualPeru={dolarMensualPeru}
                dolarFallback={dolarFallback}
                setIsInteresesModalOpen={setIsInteresesModalOpen}
                verUltimos12Meses={verUltimos12Meses}
                ebitdaMensualWindowed={eEBITDA}
                facturacionMensualWindowed={eFact}
                costosVariablesMensualWindowed={eCV}
                costosFijosMensualWindowed={eCF}
              />
            </tbody>
            {/* Inversión en Activos - con detalle colapsable arriba */}
            {!verChileYPeru && !verUnitEconomics && verInversionActivos && (
              <>
                <tr style={{ height: "8px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                {selectedYear >= 2026 && eBenchmarkInv && !inversionCollapsed && (
                  <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
                    <td
                      className={styles.conceptCell}
                      style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
                    >
                      Benchmark Inversión
                    </td>
                    {mesesWindowed.map((_, index) => {
                      const valor = eBenchmarkInv[index];
                      return (
                        <td
                          key={index}
                          className={styles.valueCell}
                          style={{
                            fontSize: "0.8rem",
                            color: "#a8d8ea",
                            fontWeight: "400",
                            padding: "6px 4px",
                            textAlign: "right",
                          }}
                        >
                          {valor === null ? "-" : index < eMs ? formatCurrency(valor, index) : "-"}
                        </td>
                      );
                    })}
                    <td
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: "#a8d8ea",
                        fontWeight: "500",
                        fontStyle: "normal",
                        padding: "6px 8px",
                        textAlign: "right",
                      }}
                    >
                      {formatCurrency(
                        eBenchmarkInv.slice(0, eMs).reduce((a, b) => a + b, 0),
                        null,
                        eBenchmarkInv
                      )}
                    </td>
                  </tr>
                )}
                <tr
                  style={{
                    backgroundColor: "#1a5276",
                    fontStyle: "italic",
                    cursor: selectedYear >= 2026 ? "pointer" : "default",
                    userSelect: "none",
                  }}
                  onClick={() => selectedYear >= 2026 && setInversionCollapsed(!inversionCollapsed)}
                >
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#fff", fontWeight: "500", fontSize: "0.85rem" }}
                  >
                    Inversión en Activos {selectedYear >= 2026 && !verUltimos12Meses && inversionCollapsed ? ">" : ""}
                  </td>
                  {mesesWindowed.map((_, index) => {
                    const valor = eInversion[index] || 0;
                    return (
                      <td
                        key={index}
                        className={styles.valueCell}
                        style={{
                          fontSize: "0.8rem",
                          color: "#fff",
                          fontWeight: "400",
                          padding: "6px 4px",
                          textAlign: "right",
                        }}
                      >
                        {index < eMs ? formatCurrency(valor, index) : "-"}
                      </td>
                    );
                  })}
                  <td
                    className={styles.valueCell}
                    style={{
                      fontSize: "0.8rem",
                      color: "#fff",
                      fontWeight: "500",
                      fontStyle: "normal",
                      padding: "6px 8px",
                      textAlign: "right",
                    }}
                  >
                    {(() => {
                      const totalInv = eInversion.slice(0, eMs).reduce((a, b) => a + b, 0);
                      const disponible = eDisponibleInv ? eDisponibleInv[Math.min(eMs, 12) - 1] || 0 : 0;
                      const base = disponible + totalInv;
                      const pct = base > 0 ? ((totalInv / base) * 100).toFixed(0) + "%" : "";
                      return `${formatCurrency(totalInv, null, eInversion)}${pct ? ` | ${pct}` : ""}`;
                    })()}
                  </td>
                </tr>
                {selectedYear >= 2026 && eBenchmarkInv && !inversionCollapsed && (
                  <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
                    <td
                      className={styles.conceptCell}
                      style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
                    >
                      Disponible Acumulado
                    </td>
                    {mesesWindowed.map((_, index) => {
                      const valor = eDisponibleInv[index];
                      return (
                        <td
                          key={index}
                          className={styles.valueCell}
                          style={{
                            fontSize: "0.8rem",
                            color: valor === null ? "#a8d8ea" : valor >= 0 ? "#66cc99" : "#ff7777",
                            fontWeight: "400",
                            padding: "6px 4px",
                            textAlign: "right",
                          }}
                        >
                          {valor === null ? "-" : index < eMs ? formatCurrency(valor, index) : "-"}
                        </td>
                      );
                    })}
                    <td
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: (eDisponibleInv[Math.min(eMs, 12) - 1] || 0) >= 0 ? "#66cc99" : "#ff7777",
                        fontWeight: "500",
                        fontStyle: "normal",
                        padding: "6px 8px",
                        textAlign: "right",
                      }}
                    >
                      {formatCurrency(eDisponibleInv[Math.min(eMs, 12) - 1] || 0, Math.min(eMs, 12) - 1)}
                    </td>
                  </tr>
                )}
              </>
            )}
            {verChileYPeru && !verUnitEconomics && (
              <>
                <tr style={{ height: "8px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                {selectedYear >= 2026 && benchmarkInversionCombinados && !inversionCollapsed && (
                  <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
                    <td
                      className={styles.conceptCell}
                      style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
                    >
                      Benchmark Inversión
                    </td>
                    {meses.map((_, index) => {
                      const valor = benchmarkInversionCombinados?.[index] || 0;
                      return (
                        <td
                          key={index}
                          className={styles.valueCell}
                          style={{
                            fontSize: "0.8rem",
                            color: "#a8d8ea",
                            fontWeight: "400",
                            padding: "6px 4px",
                            textAlign: "right",
                          }}
                        >
                          {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
                        </td>
                      );
                    })}
                    <td
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: "#a8d8ea",
                        fontWeight: "500",
                        padding: "6px 4px",
                        textAlign: "right",
                      }}
                    >
                      {formatCurrency(
                        (benchmarkInversionCombinados || Array(12).fill(0))
                          .slice(0, monthsToShow)
                          .reduce((a, b) => a + b, 0),
                        null,
                        null,
                        true
                      )}
                    </td>
                  </tr>
                )}
                <tr
                  style={{
                    backgroundColor: "#1a5276",
                    fontStyle: "italic",
                    cursor: selectedYear >= 2026 ? "pointer" : "default",
                    userSelect: "none",
                  }}
                  onClick={() => selectedYear >= 2026 && setInversionCollapsed(!inversionCollapsed)}
                >
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#fff", fontWeight: "500", fontSize: "0.85rem" }}
                  >
                    Inversión en Activos {selectedYear >= 2026 && !verUltimos12Meses && inversionCollapsed ? ">" : ""}
                  </td>
                  {meses.map((_, index) => {
                    const valor = inversionMensualesCombinados?.[index] || 0;
                    return (
                      <td
                        key={index}
                        className={styles.valueCell}
                        style={{
                          fontSize: "0.8rem",
                          color: "#fff",
                          fontWeight: "400",
                          padding: "6px 4px",
                          textAlign: "right",
                        }}
                      >
                        {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
                      </td>
                    );
                  })}
                  <td
                    className={styles.valueCell}
                    style={{
                      fontSize: "0.8rem",
                      color: "#fff",
                      fontWeight: "500",
                      padding: "6px 4px",
                      textAlign: "right",
                    }}
                  >
                    {formatCurrency(
                      (inversionMensualesCombinados || Array(12).fill(0))
                        .slice(0, monthsToShow)
                        .reduce((a, b) => a + b, 0),
                      null,
                      null,
                      true
                    )}
                  </td>
                </tr>
                {selectedYear >= 2026 && benchmarkInversionCombinados && !inversionCollapsed && (
                  <tr style={{ backgroundColor: "#1e5f8a", fontStyle: "italic" }}>
                    <td
                      className={styles.conceptCell}
                      style={{ textAlign: "left", color: "#a8d8ea", fontWeight: "500", fontSize: "0.82rem" }}
                    >
                      Disponible Acumulado
                    </td>
                    {meses.map((_, index) => {
                      const valor = disponibleInversionCombinados?.[index] || 0;
                      return (
                        <td
                          key={index}
                          className={styles.valueCell}
                          style={{
                            fontSize: "0.8rem",
                            color: valor >= 0 ? "#66cc99" : "#ff7777",
                            fontWeight: "400",
                            padding: "6px 4px",
                            textAlign: "right",
                          }}
                        >
                          {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
                        </td>
                      );
                    })}
                    <td
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color:
                          (disponibleInversionCombinados?.[Math.min(monthsToShow, 12) - 1] || 0) >= 0
                            ? "#66cc99"
                            : "#ff7777",
                        fontWeight: "500",
                        padding: "6px 4px",
                        textAlign: "right",
                      }}
                    >
                      {formatCurrency(
                        disponibleInversionCombinados?.[Math.min(monthsToShow, 12) - 1] || 0,
                        Math.min(monthsToShow, 12) - 1,
                        null,
                        true
                      )}
                    </td>
                  </tr>
                )}
              </>
            )}
            {/* Valor en Libros (Net Book Value) - siempre visible */}
            {!verChileYPeru && !verUnitEconomics && verInversionActivos && (
              <>
                <tr style={{ height: "4px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                <tr style={{ backgroundColor: "#1a3c5e", fontStyle: "italic" }}>
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#aad4ff", fontWeight: "500", fontSize: "0.85rem" }}
                  >
                    Valor en Libros de Activos
                  </td>
                  {mesesWindowed.map((_, index) => {
                    const valor = eValorActivos[index] || 0;
                    return (
                      <td
                        key={index}
                        className={styles.valueCell}
                        style={{
                          fontSize: "0.8rem",
                          color: "#aad4ff",
                          fontWeight: "400",
                          padding: "6px 4px",
                          textAlign: "right",
                        }}
                      >
                        {index < eMs ? formatCurrency(valor, index) : "-"}
                      </td>
                    );
                  })}
                  <td
                    className={styles.valueCell}
                    style={{
                      fontSize: "0.8rem",
                      color: "#aad4ff",
                      fontWeight: "500",
                      fontStyle: "normal",
                      padding: "6px 8px",
                      textAlign: "right",
                    }}
                  >
                    {formatCurrency(eValorActivos[Math.min(eMs, 12) - 1] || 0, Math.min(eMs, 12) - 1)}
                  </td>
                </tr>
              </>
            )}
            {verChileYPeru && (
              <>
                <tr style={{ height: "4px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                <tr style={{ backgroundColor: "#1a3c5e", fontStyle: "italic" }}>
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#aad4ff", fontWeight: "500", fontSize: "0.85rem" }}
                  >
                    Valor en Libros de Activos
                  </td>
                  {meses.map((_, index) => {
                    const valor = valorActivosCombinados?.[index] || 0;
                    return (
                      <td
                        key={index}
                        className={styles.valueCell}
                        style={{
                          fontSize: "0.8rem",
                          color: "#aad4ff",
                          fontWeight: "400",
                          padding: "6px 4px",
                          textAlign: "right",
                        }}
                      >
                        {index < monthsToShow ? formatCurrency(valor, index, null, true) : "-"}
                      </td>
                    );
                  })}
                  <td
                    className={styles.valueCell}
                    style={{
                      fontSize: "0.8rem",
                      color: "#aad4ff",
                      fontWeight: "500",
                      padding: "6px 4px",
                      textAlign: "right",
                    }}
                  >
                    {formatCurrency(
                      valorActivosCombinados?.[Math.min(monthsToShow, 12) - 1] || 0,
                      Math.min(monthsToShow, 12) - 1,
                      null,
                      true
                    )}
                  </td>
                </tr>
              </>
            )}
            {/* ─── Acumulados: EBITDA, EBIT, Resultado Neto ─── */}
            {verAcumulados && (
              <>
                <tr style={{ height: "4px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                {[
                  { label: "EBITDA", data: acumulados.ebitdaAcum, color: "#27ae60" },
                  { label: "EBIT", data: acumulados.ebitAcum, color: "#2980b9" },
                  { label: "Beneficio Neto", data: acumulados.resultadoAcum, color: "#bb6bd9" },
                ].map(({ label, data, color }) => (
                  <tr key={label} style={{ backgroundColor: "#1a1a2e" }}>
                    <td
                      className={styles.conceptCell}
                      style={{ textAlign: "left", color, fontWeight: "600", fontSize: "0.85rem" }}
                    >
                      {label}
                    </td>
                    {mesesWindowed.map((_, index) => {
                      const val = data[index];
                      return (
                        <td
                          key={index}
                          className={styles.valueCell}
                          style={{
                            fontSize: "0.8rem",
                            color: val !== null && val < 0 ? "#e74c3c" : "#ccc",
                            fontWeight: "500",
                            padding: "6px 4px",
                            textAlign: "right",
                          }}
                        >
                          {val !== null ? formatCurrency(val, index) : "-"}
                        </td>
                      );
                    })}
                    <td
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: data[Math.min(eMs, 12) - 1] < 0 ? "#e74c3c" : color,
                        fontWeight: "600",
                        padding: "6px 4px",
                        textAlign: "right",
                      }}
                    >
                      {formatCurrency(data[Math.min(eMs, 12) - 1] || 0, Math.min(eMs, 12) - 1)}
                    </td>
                  </tr>
                ))}
              </>
            )}

            {/* ─── Pantallas Operativas (visible solo con Unit Economics) ─── */}
            {verUnitEconomics && (
              <>
                <tr style={{ height: "4px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                <tr style={{ backgroundColor: "#1a1a2e" }}>
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#aaa", fontWeight: "600", fontSize: "0.85rem" }}
                  >
                    Pantallas Operativas
                  </td>
                  {mesesWindowed.map((_, index) => (
                    <td
                      key={index}
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: "#ccc",
                        fontWeight: "500",
                        padding: "6px 4px",
                        textAlign: "center",
                      }}
                    >
                      {index < eMs ? pantallasOperativasMensual[index] || "-" : "-"}
                    </td>
                  ))}
                  <td
                    className={styles.valueCell}
                    style={{
                      fontSize: "0.8rem",
                      color: "#aaa",
                      fontWeight: "600",
                      padding: "6px 4px",
                      textAlign: "center",
                    }}
                  >
                    -
                  </td>
                </tr>
              </>
            )}

            {/* Tipo de cambio referencia - al final de todo */}
            {verEnDolares && !verChileYPeru && (
              <>
                <tr style={{ height: "12px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                <tr style={{ backgroundColor: "#333", fontStyle: "italic" }}>
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#fff", fontWeight: "400", fontSize: "0.85rem" }}
                  >
                    Tipo de cambio referencia
                  </td>
                  {mesesWindowed.map((_, index) => (
                    <td
                      key={index}
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: "#fff",
                        fontWeight: "400",
                        padding: "6px 4px",
                        textAlign: "center",
                      }}
                    >
                      {index < eMs ? (
                        <span title={`Tipo de cambio ${mesesWindowed[index]}`}>
                          {moneda(pais)}
                          {eDolar[index]?.toLocaleString(localString(pais), {
                            minimumFractionDigits: pais === "Perú" ? 2 : 0,
                            maximumFractionDigits: pais === "Perú" ? 2 : 0,
                          })}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                  ))}
                  <td style={{ backgroundColor: "#333" }} />
                </tr>
              </>
            )}
            {verEnDolares && verChileYPeru && (
              <>
                <tr style={{ height: "12px", backgroundColor: "transparent" }}>
                  <td colSpan={14} style={{ padding: 0, border: "none" }} />
                </tr>
                <tr style={{ backgroundColor: "#333", fontStyle: "italic" }}>
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#fff", fontWeight: "400", fontSize: "0.85rem" }}
                  >
                    TC Chile (CLP/USD)
                  </td>
                  {meses.map((_, index) => (
                    <td
                      key={index}
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: "#fff",
                        fontWeight: "400",
                        padding: "6px 4px",
                        textAlign: "center",
                      }}
                    >
                      {index < monthsToShow ? (
                        <span>
                          ${" "}
                          {(pais === "Chile" ? dolarMensual[index] : dolarMensualOtroPais[index])?.toLocaleString(
                            "es-CL",
                            { minimumFractionDigits: 0, maximumFractionDigits: 0 }
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                  ))}
                  <td style={{ backgroundColor: "#333" }} />
                </tr>
                <tr style={{ backgroundColor: "#444", fontStyle: "italic" }}>
                  <td
                    className={styles.conceptCell}
                    style={{ textAlign: "left", color: "#fff", fontWeight: "400", fontSize: "0.85rem" }}
                  >
                    TC Perú (PEN/USD)
                  </td>
                  {meses.map((_, index) => (
                    <td
                      key={index}
                      className={styles.valueCell}
                      style={{
                        fontSize: "0.8rem",
                        color: "#fff",
                        fontWeight: "400",
                        padding: "6px 4px",
                        textAlign: "center",
                      }}
                    >
                      {index < monthsToShow ? (
                        <span>
                          S/{" "}
                          {(pais === "Perú" ? dolarMensual[index] : dolarMensualOtroPais[index])?.toLocaleString(
                            "es-PE",
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                  ))}
                  <td style={{ backgroundColor: "#444" }} />
                </tr>
              </>
            )}
          </table>
        )}
        {dtesSinVincular > 0 && (
          <Link
            to="/admin/conciliacion-sii"
            style={{
              display: "inline-block",
              textAlign: "left",
              padding: "4px 8px",
              margin: "24px 0 0",
              background: "#ffecd2",
              borderRadius: 4,
              color: "#e67e22",
              fontSize: "0.7rem",
              fontWeight: 600,
              textDecoration: "none",
            }}
          >
            {dtesSinVincular} DTE{dtesSinVincular === 1 ? "" : "s"} del {enteFiscal} sin vincular para {selectedYear} →
          </Link>
        )}
        {ventasCerradasSinVincular && (
          <div style={{ marginTop: 6 }}>
            <span
              style={{
                display: "inline-block",
                textAlign: "left",
                padding: "4px 8px",
                background: "#e8f4fd",
                borderRadius: 4,
                color: "#2980b9",
                fontSize: "0.7rem",
                fontWeight: 600,
              }}
            >
              {ventasCerradasSinVincular.count} venta{ventasCerradasSinVincular.count === 1 ? "" : "s"} pendiente
              {ventasCerradasSinVincular.count === 1 ? "" : "s"} de vincular en{" "}
              {mesesCompletos[ventasCerradasSinVincular.mesIdx]} por{" "}
              {formatCurrencyBase(ventasCerradasSinVincular.total)}
            </span>
          </div>
        )}
        {verUnitEconomics && (
          <p
            style={{
              fontSize: "0.75rem",
              color: "#555",
              fontStyle: "italic",
              margin: "8px 4px 0",
              lineHeight: "1.5",
            }}
          >
            <strong>Nota contable:</strong> Valores OPEX (publicidad, gestión, costos fijos) divididos por pantallas
            operativas del mes. Hardware incluido si corresponde a ingresos/costos operativos del período; excluir si es
            CAPEX de instalación. Inversión en Activos no aplica a unit economics.
          </p>
        )}
      </div>
      <InvoiceModal
        isOpen={isModalOpen}
        monthIndex={selectedMonth}
        mesesCompletos={mesesCompletos}
        facturas={[...(facturasPorMes[selectedMonth] || []), ...(facturasPorMesContratos[selectedMonth] || [])]}
        formatCurrency={formatCurrency}
        pais={pais}
        onClose={closeModal}
      />
      <AgencyCommissionModal
        isOpen={isAgencyModalOpen}
        monthIndex={selectedAgencyMonth}
        mesesCompletos={mesesCompletos}
        comisiones={[
          ...(comisionesAgenciaPorMes[selectedAgencyMonth] || []),
          ...(comisionesAgenciaContratosPorMes[selectedAgencyMonth] || []),
        ]}
        comisionesBroker={[
          ...(comisionesBrokerPorMes[selectedAgencyMonth] || []),
          ...(comisionesBrokerContratosPorMes[selectedAgencyMonth] || []),
        ]}
        costosProgramaticos={costosProgramaticosPorMes[selectedAgencyMonth] || []}
        apx={[...(apxPorMes[selectedAgencyMonth] || []), ...(apxContratosPorMes[selectedAgencyMonth] || [])]}
        oportunidades={oportunidades}
        formatCurrency={formatCurrency}
        pais={pais}
        onClose={closeAgencyModal}
      />
      <BuildingCommissionModal
        isOpen={isBuildingCommissionModalOpen}
        monthIndex={selectedBuildingCommissionMonth}
        mesesCompletos={mesesCompletos}
        comisiones={[
          ...(comisionesEdificiosPorMes[selectedBuildingCommissionMonth] || []),
          ...(comisionesEdificiosPorMesContratos[selectedBuildingCommissionMonth] || []),
        ]}
        comisionesFijas={comisionesFijasPorMes[selectedBuildingCommissionMonth] || []}
        getMoneda={getMoneda}
        formatCurrency={formatCurrency}
        onClose={closeBuildingCommissionModal}
      />
      <CommercialCommissionModal
        isOpen={isCommercialModalOpen}
        monthIndex={selectedCommercialMonth}
        selectedYear={selectedYear}
        mesesCompletos={mesesCompletos}
        oportunidades={oportunidades}
        users={users}
        valoresMensualesComisionComercial={valoresMensualesComisionComercial}
        getMoneda={getMoneda}
        formatCurrency={formatCurrency}
        pais={pais}
        onClose={closeCommercialModal}
      />
      <SoftwareDSModal
        isOpen={isSoftwareDSModalOpenA}
        monthIndex={editingSoftwareDSMonthIndexA}
        currentYear={currentYear}
        variant="publicidad"
        meses={meses}
        licencias={softwareDSLicenciasA}
        setLicencias={setSoftwareDSLicenciasA}
        previewLocal={softwareDSPreviewLocalA}
        setPreviewLocal={setSoftwareDSPreviewLocalA}
        getDolarValue={getDolarValue}
        moneda={moneda}
        pais={pais}
        localString={localString}
        pantallasCarteleria={
          detalleGestionContenidosPorMes[editingSoftwareDSMonthIndexA]?.reduce(
            (sum, item) => sum + item.pantallas,
            0
          ) || 0
        }
        costoPublicidadNeto={
          editingSoftwareDSMonthIndexA !== null
            ? softwareDSPreviewLocalA - calcularCostoSoftwareEstimado(editingSoftwareDSMonthIndexA)
            : 0
        }
        onSave={async () => {
          const licenciasCarteleria =
            detalleGestionContenidosPorMes[editingSoftwareDSMonthIndexA]?.reduce(
              (sum, item) => sum + item.pantallas,
              0
            ) || 0;
          if (softwareDSLicenciasA < licenciasCarteleria) {
            toast.error("La cantidad de licencias no puede ser menor que las asociadas a cartelería");
            return;
          }
          const mes = editingSoftwareDSMonthIndexA + 1;
          const valorLocal = softwareDSPreviewLocalA;
          try {
            await upsertCostosPublicidad({ pais, ano: selectedYear, mes, software_ds: valorLocal });
            const updated = await getCostosPublicidad({ pais, ano: selectedYear });
            setCostosPublicidadData(updated);
            toast.success("Software DS (Publicidad) guardado");
            setIsSoftwareDSModalOpenA(false);
            setEditingSoftwareDSMonthIndexA(null);
            setSoftwareDSLicenciasA(0);
            setSoftwareDSPreviewLocalA(0);
          } catch (err) {
            console.error(err);
            toast.error("Error al guardar");
          }
        }}
        onClose={() => setIsSoftwareDSModalOpenA(false)}
      />
      <HardwareFlexModal
        isOpen={isHardwareFlexModalOpen}
        monthIndex={selectedHardwareFlexMonth}
        selectedYear={selectedYear}
        meses={meses}
        puedeEditar={puedeEditar}
        formatCurrency={formatCurrency}
        compraHardware={compraHardwareMensual[selectedHardwareFlexMonth]}
        instalacion={instalacionMensual[selectedHardwareFlexMonth]}
        materiales={materialesMensual[selectedHardwareFlexMonth]}
        otrosCostos={otrosCostosMensual[selectedHardwareFlexMonth]}
        nuevoCostoNegocioId={nuevoCostoNegocioId}
        setNuevoCostoNegocioId={setNuevoCostoNegocioId}
        nuevoCostoMonto={nuevoCostoMonto}
        setNuevoCostoMonto={setNuevoCostoMonto}
        nuevoCostoTipo={nuevoCostoTipo}
        setNuevoCostoTipo={setNuevoCostoTipo}
        negociosCarteleria={negociosCarteleria}
        getNombreNegocio={getNombreNegocio}
        costosDelMes={costosHardwareFlex.filter((c) => c.mes === selectedHardwareFlexMonth + 1)}
        onAdd={async () => {
          if (!nuevoCostoMonto || Number(nuevoCostoMonto) <= 0) {
            toast.error("Ingresa un monto válido");
            return;
          }
          try {
            const { error } = await client
              .from("costos_hardware_flex")
              .insert({
                negocio_id: nuevoCostoNegocioId || null,
                pais: pais,
                ano: selectedYear,
                mes: selectedHardwareFlexMonth + 1,
                tipo: nuevoCostoTipo,
                monto: Number(nuevoCostoMonto),
              })
              .select();
            if (error) throw error;
            await recargarHardwareFlex();
            setNuevoCostoNegocioId(null);
            setNuevoCostoMonto("");
            setNuevoCostoTipo("compra_hardware");
            toast.success("Costo agregado correctamente");
          } catch (err) {
            console.error("Error guardando:", err);
            toast.error("Error al guardar: " + err.message);
          }
        }}
        onDelete={async (id) => {
          if (!window.confirm("¿Eliminar este costo?")) return;
          try {
            await deleteCostoHardwareFlex(id);
            await recargarHardwareFlex();
            toast.success("Eliminado");
          } catch {
            toast.error("Error al eliminar");
          }
        }}
        onClose={closeHardwareFlexModal}
      />
      <HardwareIngresosModal
        isOpen={isHardwareIngresosModalOpen}
        detalleHardwareIngresos={detalleHardwareIngresos}
        selectedYear={selectedYear}
        currentYear={currentYear}
        mesesCompletos={mesesCompletos}
        pais={pais}
        moneda={moneda}
        localString={localString}
        formatCurrency={formatCurrency}
        getNombreNegocio={getNombreNegocio}
        getFechaFacturaHardware={getFechaFacturaHardware}
        getDolarValue={getDolarValue}
        getUFValue={getUFValue}
        convertirAMonedaLocal={convertirAMonedaLocal}
        costosGestionData={costosGestionData}
        ingresosHardwareTotal={
          detalleHardwareIngresos ? ingresosHardwareMensual[detalleHardwareIngresos.monthIndex] : 0
        }
        editingFechaId={editingFechaId}
        setEditingFechaId={setEditingFechaId}
        editingFechaValue={editingFechaValue}
        setEditingFechaValue={setEditingFechaValue}
        onSaveFecha={async (negocioId, monthIdx) => {
          if (!editingFechaValue) {
            toast.error("Selecciona una fecha");
            return;
          }
          try {
            await client.from("costos_gestion_contenidos").upsert(
              {
                negocio_id: negocioId,
                pais,
                ano: selectedYear,
                mes: monthIdx + 1,
                fecha_factura: editingFechaValue,
              },
              { onConflict: "pais,ano,mes,negocio_id" }
            );
            const { data } = await client
              .from("costos_gestion_contenidos")
              .select("*")
              .eq("pais", pais)
              .eq("ano", selectedYear);
            setCostosGestionData(data || []);
            setModalRefresh((prev) => prev + 1);
            toast.success("Fecha guardada");
            setEditingFechaId(null);
            setEditingFechaValue("");
          } catch {
            toast.error("Error al guardar");
          }
        }}
        onClose={() => setIsHardwareIngresosModalOpen(false)}
      />
      <EditCostModal
        isOpen={isEditModalOpen}
        editingConcept={editingConcept}
        editValue={editValue}
        setEditValue={setEditValue}
        meses={meses}
        currentYear={currentYear}
        getMoneda={getMoneda}
        onSave={saveCost}
        onClose={closeEditModal}
      />
      <GestionContenidosModal
        isOpen={isGestionContenidosModalOpen}
        monthIndex={selectedGestionContenidosMonth}
        selectedYear={selectedYear}
        currentYear={currentYear}
        mesesCompletos={mesesCompletos}
        pais={pais}
        localString={localString}
        moneda={moneda}
        formatCurrency={formatCurrency}
        formatFee={formatFee}
        getDolarValue={getDolarValue}
        convertirAMonedaLocal={convertirAMonedaLocal}
        detalleItems={detalleGestionContenidosPorMes[selectedGestionContenidosMonth] || []}
        costosGestionData={costosGestionData}
        editingFechaId={editingFechaId}
        setEditingFechaId={setEditingFechaId}
        editingFechaValue={editingFechaValue}
        setEditingFechaValue={setEditingFechaValue}
        onSaveFecha={async (negocioId, monthIdx) => {
          if (!editingFechaValue) {
            toast.error("Selecciona una fecha");
            return;
          }
          try {
            await client.from("costos_gestion_contenidos").upsert(
              {
                negocio_id: negocioId,
                pais,
                ano: selectedYear,
                mes: monthIdx + 1,
                fecha_factura: editingFechaValue,
              },
              { onConflict: "pais,ano,mes,negocio_id" }
            );
            const { data } = await client
              .from("costos_gestion_contenidos")
              .select("*")
              .eq("pais", pais)
              .eq("ano", selectedYear);
            setCostosGestionData(data || []);
            setModalRefresh((prev) => prev + 1);
            toast.success("Fecha guardada");
            setEditingFechaId(null);
            setEditingFechaValue("");
          } catch {
            toast.error("Error al guardar");
          }
        }}
        onClose={closeGestionContenidosModal}
      />
      <SoftwareDSModal
        isOpen={isSoftwareDSModalOpenC}
        monthIndex={editingSoftwareDSMonthIndexC}
        currentYear={currentYear}
        variant="gestion"
        meses={meses}
        licencias={softwareDSLicenciasC}
        setLicencias={setSoftwareDSLicenciasC}
        previewLocal={softwareDSPreviewLocalC}
        setPreviewLocal={setSoftwareDSPreviewLocalC}
        getDolarValue={getDolarValue}
        moneda={moneda}
        pais={pais}
        localString={localString}
        pantallasActivas={
          detalleGestionContenidosPorMes[editingSoftwareDSMonthIndexC]?.reduce(
            (sum, item) => sum + item.pantallas,
            0
          ) || 0
        }
        onSave={async () => {
          const mes = editingSoftwareDSMonthIndexC + 1;
          const valorLocal = softwareDSPreviewLocalC;
          try {
            await upsertCostoGestion({
              negocio_id: null,
              pais,
              ano: selectedYear,
              mes,
              tipo: "software_ds",
              value: valorLocal,
            });
            const freshData = await client
              .from("costos_gestion_contenidos")
              .select("*")
              .eq("pais", pais)
              .eq("ano", selectedYear);
            setCostosGestionData(freshData.data || []);
            toast.success("Software DS (Gestión & Contenidos) guardado");
            setIsSoftwareDSModalOpenC(false);
            setEditingSoftwareDSMonthIndexC(null);
            setSoftwareDSLicenciasC(0);
            setSoftwareDSPreviewLocalC(0);
          } catch (err) {
            console.error(err);
            toast.error("Error al guardar");
          }
        }}
        onClose={() => setIsSoftwareDSModalOpenC(false)}
      />
      <BTLModal
        isOpen={isBTLModalOpen}
        monthIndex={selectedBTLMonth}
        currentYear={currentYear}
        mesesCompletos={mesesCompletos}
        salesBTL={salesBTL}
        clientes={clientes}
        edificios={edificios}
        formatCurrency={formatCurrency}
        editingBTLId={editingBTLId}
        setEditingBTLId={setEditingBTLId}
        tempOtrosCostos={tempOtrosCostos}
        setTempOtrosCostos={setTempOtrosCostos}
        guardarOtrosCostosBTL={guardarOtrosCostosBTL}
        pais={pais}
        onClose={() => setIsBTLModalOpen(false)}
      />
      <AsesoriaExternaModal
        isOpen={isAsesoriaModalOpen}
        monthIndex={editingAsesoriaMonthIndex}
        currentYear={currentYear}
        meses={meses}
        asesoriaUsd={asesoriaUsd}
        setAsesoriaUsd={setAsesoriaUsd}
        asesoriaFecha={asesoriaFecha}
        setAsesoriaFecha={setAsesoriaFecha}
        asesoriaPreviewLocal={asesoriaPreviewLocal}
        setAsesoriaPreviewLocal={setAsesoriaPreviewLocal}
        getDolarValue={getDolarValue}
        guardarCostoFijo={guardarCostoFijo}
        formatCurrency={formatCurrency}
        localString={localString}
        pais={pais}
        onClose={() => setIsAsesoriaModalOpen(false)}
        onSaved={() => {
          setIsAsesoriaModalOpen(false);
          setAsesoriaUsd(0);
          setAsesoriaFecha("");
          setAsesoriaPreviewLocal(0);
          setEditingAsesoriaMonthIndex(null);
        }}
      />
      <VariosModal
        isOpen={isVariosModalOpen}
        monthIndex={editingVariosMonthIndex}
        selectedYear={selectedYear}
        mesesCompletos={mesesCompletos}
        variosDetalleTemp={variosDetalleTemp}
        nuevoVariosConcepto={nuevoVariosConcepto}
        setNuevoVariosConcepto={setNuevoVariosConcepto}
        nuevoVariosMonto={nuevoVariosMonto}
        setNuevoVariosMonto={setNuevoVariosMonto}
        agregarItemVarios={agregarItemVarios}
        eliminarItemVarios={eliminarItemVarios}
        calcularTotalVarios={calcularTotalVarios}
        guardarVariosDetalle={guardarVariosDetalle}
        cerrarModalVarios={cerrarModalVarios}
        formatCurrency={formatCurrency}
        moneda={moneda}
        pais={pais}
      />

      {/* Modal de Intereses (solo Chile) */}
      <InteresesModal isOpen={isInteresesModalOpen} onClose={() => setIsInteresesModalOpen(false)} />

      <ERChartModal
        open={isChartModalOpen}
        onClose={() => setIsChartModalOpen(false)}
        facturacionMensual={eFact}
        costosVariablesMensual={eCV}
        costosFijosMensual={eCF || Array.from({ length: 12 }, (_, i) => sumarCostosFijosMes(i))}
        ebitdaMensual={eEBITDA}
        formatCurrency={formatCurrency}
        selectedYear={selectedYear}
        verUltimos12Meses={verUltimos12Meses}
      />
    </div>
  );
};
